import type { Dict } from "../lib/i18n";

// "Smart pantry": stock, nutrition, expiry and restocking. Keys prefixed "fridge.".
export default {
  zh: {
    "fridge.life.title": "保质时间",
    "fridge.life.tipsTitle": "拍日期的小窍门",
    "fridge.life.tipWhere": "对准印日期的地方：瓶盖、盒子侧面或底部",
    "fridge.life.tipSharp": "光线要亮，靠近一点，等对焦清楚再拍",
    "fridge.life.tipMore": "如果写着“开封后几天内吃完”“冷藏”“冷冻”，也一起拍进去",
    "fridge.life.photo": "拍包装上的日期",
    "fridge.life.photoBtn": "拍日期",
    "fridge.life.readFail": "没读出日期。请靠近一点再拍一次，或者自己填日期。",
    "fridge.life.readUseBy": "保质期到 {date}",
    "fridge.life.readBest": "最佳食用期到 {date}",
    "fridge.life.readOpen": "开封后 {n} 天内吃完",
    "fridge.life.store.fridge": "要冷藏",
    "fridge.life.store.freezer": "要冷冻",
    "fridge.life.store.room": "常温、干燥处",
    "fridge.life.noFreeze": "不能冷冻",
    "fridge.life.readDone": "读到了：{what}",
    "fridge.life.kind": "日期类型",
    "fridge.life.use_by": "保质期",
    "fridge.life.best_before": "最佳食用期",
    "fridge.life.use_byMeans": "过了就不能吃（肉、鱼、鲜奶等）",
    "fridge.life.best_beforeMeans": "过了先看一看、闻一闻，常常还能吃",
    "fridge.life.noDate": "还没有日期。拍一下包装上的日期，或者自己填。",
    "fridge.life.leftUseBy": "保质期到 {date}，还有 {n} 天",
    "fridge.life.leftBest": "最佳食用期到 {date}，还有 {n} 天",
    "fridge.life.todayUseBy": "今天是保质期最后一天：今天吃完，或者马上冷冻",
    "fridge.life.todayBest": "今天是最佳食用期的最后一天",
    "fridge.life.pastUseBy": "已过保质期 {n} 天：不能再吃，一定要扔掉",
    "fridge.life.pastBest": "已过最佳食用期 {n} 天",
    "fridge.life.checkHow": "先看一看、闻一闻、尝一小口：颜色、气味、味道都正常，就尽快吃掉；发霉、胀袋、有怪味就扔掉。",
    "fridge.life.expiredHow": "冷冻也救不回来了，请扔掉。",
    "fridge.life.barLabel": "保质时间已过去 {pct}%",
    "fridge.life.bought": "{date} 买入",
    "fridge.life.opened": "{date} 开封",
    "fridge.life.frozen": "{date} 冷冻",
    "fridge.life.frozenLeft": "🧊 冷冻中，建议 {date} 前吃完（还有 {n} 天）",
    "fridge.life.frozenPast": "🧊 冷冻已超过建议时间 {n} 天：还安全，但口感会变差，尽快吃掉",
    "fridge.life.openBtn": "今天开封了（{n} 天内吃完）",
    "fridge.life.freezeBtn": "放进冷冻室（约 {n} 个月）",
    "fridge.life.thawBtn": "解冻了（1 天内吃完，别再冷冻）",
    "fridge.life.editDate": "改日期",
    "fridge.life.openDays": "开封后可以放几天",
    "fridge.life.greenBin": "环保地扔：食物倒进厨余（GFT）垃圾桶，包装洗干净后按塑料、纸、玻璃分类回收。",
    "fridge.pastBest": "过最佳期 {n} 天",
    "fridge.focus.check": "过了最佳食用期，先看闻尝",
    "fridge.note.checkOne": "{name} 过了最佳食用期 {n} 天。先看一看、闻一闻，没问题就尽快吃掉，别浪费～",
    "fridge.note.frozenPast": "{name} 在冷冻室放太久了，还安全，但越放越不好吃，这几天就吃掉吧～",
    "fridge.note.frozenSoon": "{name} 在冷冻室还能放 {n} 天，安排一顿吃掉它吧～",
    "fridge.note.orFreeze": "吃不完？今天放进冷冻室，可以多放几个月。",
    "fridge.board.sumCheck": "{n} 样要检查",
    "fridge.note.expiredOne": "{name} 已过保质期 {n} 天，一定要扔掉，千万别再吃了。",
    "fridge.item.deleteStock": "还有库存：如果是扔掉了，请改用“扔掉”，这样会记进每月报告的浪费和花费里。",
    "fridge.cook.deductEstimated": "{names} 没有包装重量，按常见分量从食材库扣除了，可以在食材库里核对一下剩多少。",
    "fridge.energy.f.phoneExtra": "记录的运动比手表多出的部分 = {v} 千卡（手表没戴着时做的运动）",
    "fridge.energy.f.exerciseNoWalk": "其他运动（散步已经算在步数里）= {v} 千卡",
    "fridge.energy.f.phoneActive": "手机/手表记录的活动消耗 = {v} 千卡（走路和戴着手表时的运动都在里面）",
    "fridge.item.labelPhoto": "营养表照片（点开看大图）",
    "fridge.labelPhoto.title": "拍营养表：{name}",
    "fridge.labelPhoto.save": "存进食材库",
    "fridge.energy.f.phoneBase": "休息和消化 = 基础代谢 {bmr} × 1.1 = {v} 千卡",
    "fridge.energy.f.stepsBase": "坐着的基本消耗 = 基础代谢 {bmr} × 1.2 = {v} 千卡",
    "fridge.energy.f.steps": "走路 = {steps} 步 × 0.00057 × 体重 {w} = {v} 千卡（约每步 0.04 千卡）",
    "fridge.energy.f.total": "今天总消耗 = {parts} = {v} 千卡",
    "fridge.energy.act2.title": "今天的步数和活动",
    "fridge.energy.act2.hint": "看一眼手机里的“健康”（苹果）或 Google Fit / 三星健康（安卓）上今天的步数填进来；手表或健身房器械显示的活动消耗也可以填。填了活动消耗，就以它为准（已包含走路和运动，不会重复计算）。",
    "fridge.energy.act2.steps": "步数",
    "fridge.energy.act2.active": "活动消耗（千卡，可不填）",
    "fridge.energy.act2.save": "保存今天的活动",
    "fridge.energy.act2.invalid": "步数请填 0–100000，活动消耗 0–5000 千卡。",
    "fridge.energy.act2.fromPhone": "今天的数据来自手机自动同步。",
    "fridge.energy.sync.title": "苹果手机：每天自动同步（快捷指令）",
    "fridge.energy.sync.last": "上次同步 {when}",
    "fridge.energy.sync.intro": "用 iPhone 自带的“快捷指令”App，每天晚上自动把“健康”里的步数和活动消耗送进 NutriCart。只需要设置一次。",
    "fridge.energy.sync.makeLink": "生成我的同步链接",
    "fridge.energy.sync.newLink": "重新生成同步链接（旧的会失效）",
    "fridge.energy.sync.copy": "复制链接",
    "fridge.energy.sync.copied": "已复制",
    "fridge.energy.sync.step1": "点上面“生成我的同步链接”，再点“复制链接”。这个链接只属于你，不要发给别人。",
    "fridge.energy.sync.step2": "打开 iPhone 的“快捷指令”App → 下方“自动化” → 右上角“+” → 选“特定时间”，设每天 21:30，选“立即运行”，点“下一步”。",
    "fridge.energy.sync.step3": "选“新建空白自动化”，添加操作“查找健康样本”：类型选“步数”，开始日期选“今天”；再添加“计算统计数据”，选“总和”。",
    "fridge.energy.sync.step4": "再添加一次“查找健康样本”，类型选“活动能量”，开始日期“今天”；再添加“计算统计数据”，选“总和”。",
    "fridge.energy.sync.step5": "添加“获取 URL 内容”：粘贴你的同步链接，方法选“POST”，请求体选“JSON”，加两个字段：steps = 第一个“统计数据”，activeKcal = 第二个“统计数据”。",
    "fridge.energy.sync.step6": "点“完成”。可以先手动运行一次试试；回到这里刷新，看到“来自手机自动同步”就成功了。（不同 iOS 版本里的名称可能略有不同。）",
    "fridge.energy.sync.android": "安卓手机：暂时请每天手动填步数（打开 Google Fit 或三星健康看一眼，10 秒钟）。",
    "fridge.add.noNumbers": "找到了“{name}”，但公开数据库里还没有它的营养数据。拍一下包装上的营养表，马上就能读出来，以后谁扫这个条形码都能直接看到。",
    "fridge.board.sign": "—— 爱你的食材库",
    "fridge.note.lowListed": "{names} 用完啦，我已经帮你加进购物清单了，安心去买就好 🛒",
    "fridge.note.lowRemind": "{names} 快用完了，记得补货哦～",
    "fridge.note.andMore": "{names} 等 {n} 样",
    "fridge.board.sumExpired": "{n} 样过期",
    "fridge.board.sumSoon": "{n} 样快到期",
    "fridge.board.sumLow": "{n} 样待购买",
    "fridge.board.page": "第 {n} / {total} 页",
    "fridge.board.prev": "上一页",
    "fridge.board.next": "下一页",
    "fridge.board.pages": "翻页",
    "fridge.board.title": "今天的小纸条",
    "fridge.note.soonToday": "{name} 今天到期，今天就把它吃掉吧，别浪费哦～",
    "fridge.note.soonOne": "{name} 还有 {n} 天到期，记得先吃它哦～",
    "fridge.note.allGood": "食材都很新鲜，库存也够。今天也要好好吃饭哦 💚",
    "fridge.note.look": "去看看",
    "fridge.seeAll": "查看全部 {n} 样食材",
    "fridge.backToShelves": "全部分类",
    "fridge.focus.expired": "过期了，该扔了",
    "fridge.focus.soon": "快到期，先吃它们",
    "fridge.focus.low": "该补货了",
    "fridge.allItems": "全部食材",
    "fridge.shelfEmpty": "这里还空着。点下面的“放进食材库”添加吧。",
    "fridge.item.throwNow": "为了健康，请扔掉",
    "fridge.until": "到 {date}",
    "fridge.short.carbs": "碳水",
    "fridge.short.sugar": "糖",
    "fridge.short.fat": "脂肪",
    "fridge.short.salt": "盐",
    "fridge.title": "食材库",
    "fridge.search": "搜索食材",
    "fridge.all": "全部",
    "fridge.cat.staples": "主食粮油",
    "fridge.cat.produce": "蔬菜水果",
    "fridge.cat.protein": "肉蛋鱼豆",
    "fridge.cat.dairy": "奶制品",
    "fridge.cat.frozen": "冷冻",
    "fridge.cat.drinks": "饮料",
    "fridge.cat.condiments": "调味品",
    "fridge.cat.snacks": "零食",
    "fridge.cat.other": "其他",
    "fridge.unit.pack": "包",
    "fridge.unit.bottle": "瓶",
    "fridge.unit.piece": "个",
    "fridge.add": "放进食材库",
    "fridge.cook": "做一道菜",
    "fridge.emptyTitle": "食材库还是空的",
    "fridge.emptyBody": "扫一下包装上的条形码，名称、营养成分、包装大小和到期日都会自动填好。也可以把拍过的小票上的食品一次放进来。",
    "fridge.noMatch": "没有找到符合的食材。",
    "fridge.per100g": "每 100 g",
    "fridge.per100ml": "每 100 ml",
    "fridge.noNutrition": "还没有营养数据",
    "fridge.expiresIn": "{n} 天后到期",
    "fridge.expiresToday": "今天到期",
    "fridge.expiredAgo": "过期 {n} 天",
    "fridge.noDate": "未设到期日",
    "fridge.estimated": "估计",
    "fridge.out": "用完了",
    "fridge.export": "导出 Excel 表格",
    "fridge.exported": "表格已下载",
    "fridge.listAdded": "{name} 不多了，已加入购物清单",
    "fridge.intoFridge": "已放进食材库：{name}",

    "fridge.item.left": "还有多少",
    "fridge.item.expires": "到期日",
    "fridge.item.estimatedNote": "这是按分类估计的日期，请按包装上的日期改一下。",
    "fridge.item.nutrition": "营养成分（{basis}）",
    "fridge.item.fill": "补上营养成分",
    "fridge.item.typical": "≈ 是这种食物的常见值，仅供参考；拍包装上的营养表或扫条形码会更准。",
    "fridge.item.fillExact": "想要更准？扫条形码或拍营养表：",
    "fridge.item.scan": "扫条形码",
    "fridge.item.label": "拍营养表",
    "fridge.item.restock": "补货提醒",
    "fridge.item.restockLine": "剩 {min} {unit} 或更少时，把 {qty} {unit} 加入购物清单",
    "fridge.item.minQty": "剩多少时提醒",
    "fridge.item.restockQty": "建议买多少",
    "fridge.item.auto": "自动加入购物清单",
    "fridge.item.details": "分类、单位和包装",
    "fridge.item.shelf": "分类",
    "fridge.item.unit": "单位",
    "fridge.item.packSize": "每{unit}多少克或毫升",
    "fridge.item.packHint": "做菜时按克数扣掉库存要用到",
    "fridge.item.discard": "扔掉（坏了或过期）",
    "fridge.item.discarded": "已扔掉：{name}",
    "fridge.item.delete": "以后不再放这个",
    "fridge.item.deleteTitle": "从食材库里删除“{name}”？",
    "fridge.item.deleteBody": "营养数据和补货提醒会一起删除。只是吃完了的话，不用删除，数量为 0 时会提醒你补货。",
    "fridge.item.deleted": "已删除",

    "fridge.add.title": "放进食材库",
    "fridge.add.scan": "扫条形码",
    "fridge.add.scanSub": "推荐：名称、营养、包装大小自动填好",
    "fridge.add.receipt": "从小票放入",
    "fridge.add.receiptSub": "拍新小票，或选还没放进来的小票：记账和放进食材库一次完成",
    "fridge.add.type": "输入名称",
    "fridge.add.typeSub": "蔬菜水果、散装食品等没有条形码的",
    "fridge.add.name": "名称",
    "fridge.add.namePh": "例如：西红柿",
    "fridge.add.qty": "数量",
    "fridge.add.found": "找到了",
    "fridge.add.notFound": "数据库里没有这个商品。输入名称，再拍一下营养表就行。",
    "fridge.add.labelBtn": "拍营养表，自动读出营养",
    "fridge.add.reading": "正在读营养表…{pct}%",
    "fridge.add.labelRead": "已读出营养成分，请核对一下",
    "fridge.add.labelFail": "没读清楚。可以先放进食材库，以后再补。",
    "fridge.add.save": "放进食材库",
    "fridge.add.merged": "食材库里已经有了，数量 +{n}",
    "fridge.add.again": "再扫一个",
    "fridge.exp.d3": "3 天",
    "fridge.exp.w1": "1 周",
    "fridge.exp.w2": "2 周",
    "fridge.exp.m1": "1 个月",
    "fridge.exp.m3": "3 个月",
    "fridge.exp.m6": "半年",
    "fridge.exp.y1": "1 年",
    "fridge.exp.hint": "按包装上的日期填。不填的话，按分类估计一个日期。",

    "fridge.receipt.button": "放进食材库",
    "fridge.receipt.skip": "不用了",
    "fridge.item.bought": "在 {store} 买的 · {date}{price} · 看小票",
    "fridge.receipt.newPhoto": "拍一张新小票（记账和放进食材库一次完成）",
    "fridge.recipe.title": "用现有食材做什么？",
    "fridge.recipe.card": "用现有食材可以做",
    "fridge.recipe.ask": "不知道做什么？看看用现有食材能做的菜",
    "fridge.recipe.intro": "按你食材库里有的东西挑出来的家常菜，快过期的食材优先用掉。",
    "fridge.recipe.none": "现在的食材还凑不出一道菜",
    "fridge.recipe.noneSub": "多放几样常用食材进来（比如鸡蛋、番茄、土豆、鱼、肉），这里就会推荐。",
    "fridge.recipe.usesUp": "用掉快过期的 {names}",
    "fridge.recipe.allHere": "食材都齐了",
    "fridge.recipe.missing": "还缺 {names}",
    "fridge.recipe.back": "看其他菜",
    "fridge.recipe.minutes": "大约 {n} 分钟",
    "fridge.recipe.ingredients": "食材",
    "fridge.recipe.optional": "可选",
    "fridge.recipe.notHome": "家里没有",
    "fridge.recipe.basics": "调料：{names}",
    "fridge.recipe.steps": "做法",
    "fridge.recipe.cookHint": "点“就做这个”，会把用到的食材和分量填好，算出每份的热量、糖和盐，并从食材库里扣掉。",
    "fridge.recipe.cook": "就做这个",
    "fridge.recipe.buy": "缺的 {n} 样加到购物清单",
    "fridge.recipe.listed": "已把 {n} 样加到购物清单",
    "fridge.cuisine.chinese": "中餐",
    "fridge.cuisine.dutch": "荷兰菜",
    "fridge.cuisine.italian": "意大利菜",
    "fridge.cuisine.french": "法国菜",
    "fridge.cuisine.german": "德国菜",
    "fridge.cuisine.czech": "捷克菜",
    "fridge.cuisine.spanish": "西班牙菜",
    "fridge.cuisine.indonesian": "印尼/苏里南菜",
    "fridge.cuisine.turkish": "土耳其/摩洛哥菜",
    "fridge.cuisine.indian": "印度菜",
    "fridge.cuisine.korean": "韩国菜",
    "fridge.cuisine.japanese": "日本菜",
    "fridge.cuisine.western": "家常西式",
    "fridge.recipe.likedNow": "先看：{names}",
    "fridge.recipe.likedAll": "所有菜系（点这里选喜欢的）",
    "fridge.recipe.likedHint": "选你家喜欢的菜系，可以多选；推荐会先显示这些菜。一个都不选就显示全部。",
    "fridge.recipe.ours": "我家的菜",
    "fridge.recipe.oursSub": "这是你家做过 {n} 次的菜。",
    "fridge.recipe.forYou": "你喜欢的菜系",
    "fridge.recipe.others": "其他菜系",
    "fridge.recipe.showOthers": "看看其他菜系（{n} 道）",
    "fridge.recipe.cookedTimes": "做过 {n} 次",
    "fridge.recipe.forget": "不再推荐这道菜",
    "fridge.recipe.forgotten": "以后不再推荐“{name}”",
    "fridge.energy.open": "今天的能量平衡",
    "fridge.energy.openSub": "吃进 − 消耗，和你自己的健康标准比",
    "fridge.energy.title": "今天的能量平衡",
    "fridge.energy.diffTitle": "今天的能量差（吃进 − 消耗）",
    "fridge.energy.deficit": "今天是“亏空”：消耗比吃进多，约等于减掉 {kg} 公斤脂肪。",
    "fridge.energy.surplus": "今天是“盈余”：吃进比消耗多，约等于多存 {kg} 公斤脂肪。",
    "fridge.energy.even": "今天吃进和消耗差不多，体重会保持。",
    "fridge.energy.formula": "计算公式（用你自己的数字）",
    "fridge.energy.f.bmr": "基础代谢（Mifflin–St Jeor 公式）= 10 × 体重 {w} + 6.25 × 身高 {h} − 5 × 年龄 {a} {s} = {v} 千卡",
    "fridge.energy.f.life": "日常消耗 = 基础代谢 {bmr} × 活动系数 {f}（{act}）= {v} 千卡",
    "fridge.energy.f.exercise": "今天记录的运动 = {v} 千卡（{min} 分钟）",
    "fridge.energy.f.burned": "今天总消耗 = {life} + {ex} = {v} 千卡",
    "fridge.energy.f.calib": "个人校正 = {v} 千卡（按你过去的体重变化）",
    "fridge.energy.f.burnedCal": "今天总消耗 = {life} + {ex} + ({calib}) = {v} 千卡",
    "fridge.energy.cal.title": "和实际体重对照",
    "fridge.energy.cal.notYet": "需要至少 2 周、大部分天都记了饮食，并且称过两次体重（相隔 14 天以上），才能和实际体重对照。",
    "fridge.energy.cal.compare": "过去 {days} 天（{logged} 天记了饮食）：按公式体重应该变化 {pred} 公斤，实际变化 {act} 公斤。",
    "fridge.energy.cal.fits": "公式和你的身体很吻合，不需要校正。",
    "fridge.energy.cal.more": "你的身体每天大约比公式多消耗 {v} 千卡。",
    "fridge.energy.cal.less": "你的身体每天大约比公式少消耗 {v} 千卡（也可能是有些饮食没记上）。",
    "fridge.energy.cal.apply": "按实际校正（每天 {v} 千卡）",
    "fridge.energy.cal.clear": "取消校正（现在 {v} 千卡）",
    "fridge.energy.f.eaten": "今天吃进 = {v} 千卡（饮食里记了 {n} 样）",
    "fridge.energy.f.diff": "能量差 = 吃进 {eaten} − 消耗 {burned} = {v} 千卡 ≈ {kg} 公斤脂肪（{per} 千卡 ≈ 1 公斤）",
    "fridge.energy.standard": "和我的健康标准比",
    "fridge.energy.goal.own": "热量标准：你自己设的每天 {v} 千卡。",
    "fridge.energy.goal.slim": "热量标准（减脂）：总消耗 {burned} − {d} = {v} 千卡。",
    "fridge.energy.goal.keep": "热量标准（保持体重）：等于总消耗 {v} 千卡。",
    "fridge.energy.left": "今天还可以吃 {v} 千卡。",
    "fridge.energy.over": "今天超出 {v} 千卡。",
    "fridge.energy.sugar": "糖：今天 {v} 克 / 上限 {max} 克",
    "fridge.energy.salt": "盐：今天 {v} 克 / 上限 {max} 克",
    "fridge.energy.bmi": "BMI = 体重 {w} ÷ 身高 {h}² = {v}（{band}；18.5–24.9 为正常）",
    "fridge.energy.band.under": "偏瘦",
    "fridge.energy.band.normal": "正常",
    "fridge.energy.band.over": "偏重",
    "fridge.energy.band.obese": "肥胖",
    "fridge.energy.note": "一天还没结束时，吃进和运动还会变化，晚饭后看最准。这些是估算，不能代替医生的意见；要改糖、盐、热量的上限，请到“饮食 › 目标”。",
    "fridge.energy.toMeals": "去记饮食和运动",
    "fridge.energy.editBody": "改身体资料",
    "fridge.energy.form.intro": "算消耗需要这些资料，只用来计算，不会给别人看。",
    "fridge.energy.form.sex": "性别",
    "fridge.energy.form.year": "出生年份",
    "fridge.energy.form.height": "身高（厘米）",
    "fridge.energy.form.weight": "现在的体重（公斤）",
    "fridge.energy.form.weightFrom": "体重记录里最近一次是 {date}",
    "fridge.energy.form.activity": "平时的活动量（不算另外记录的运动）",
    "fridge.energy.form.save": "保存并计算",
    "fridge.energy.form.invalid": "请把每一项都填好：出生年份、身高 80–250 厘米、体重 20–400 公斤，并选性别和活动量。",
    "fridge.energy.sex.female": "女",
    "fridge.energy.sex.male": "男",
    "fridge.energy.act.sedentary": "久坐",
    "fridge.energy.act.light": "轻度活动",
    "fridge.energy.act.moderate": "中度活动",
    "fridge.energy.act.active": "活动多",
    "fridge.energy.act.very": "非常活跃",
    "fridge.energy.actHint.sedentary": "大部分时间坐着，很少走动",
    "fridge.energy.actHint.light": "坐着工作，每天走走路、做家务",
    "fridge.energy.actHint.moderate": "经常站着或走动，比如店员、带小孩",
    "fridge.energy.actHint.active": "体力活多，或每天都运动",
    "fridge.energy.actHint.very": "重体力劳动，或每天高强度训练",
    "fridge.baby.open": "给宝宝做饭",
    "fridge.baby.openSub": "按月龄用现有食材做辅食",
    "fridge.baby.title": "给宝宝做什么？",
    "fridge.baby.intro": "按宝宝的月龄，用食材库现有的食材做辅食；快过期的先用。",
    "fridge.baby.ageLabel": "宝宝多大",
    "fridge.baby.age.6m": "6–8 个月（泥糊）",
    "fridge.baby.age.9m": "9–12 个月（碎末、手指食物）",
    "fridge.baby.age.1y": "1–3 岁（小份家常饭）",
    "fridge.baby.rulesTitle": "这个月龄要注意",
    "fridge.baby.rules.6m.1": "满 6 个月才开始吃辅食，母乳或配方奶仍是主要营养。",
    "fridge.baby.rules.6m.2": "不加盐、糖、酱油、鸡精；1 岁前绝对不能吃蜂蜜。",
    "fridge.baby.rules.6m.3": "每次只加一种新食物，观察 3 天再加下一种。",
    "fridge.baby.rules.6m.4": "从细泥开始，每次 1–2 小勺；肉、鱼、蛋一定要全熟。",
    "fridge.baby.rules.9m.1": "从泥过渡到碎末和软块，练习咀嚼，让宝宝自己抓着吃。",
    "fridge.baby.rules.9m.2": "仍然不加盐、糖、蜂蜜；每天吃一点含铁的肉、鱼、蛋。",
    "fridge.baby.rules.9m.3": "葡萄、蓝莓、小番茄切成四瓣；不吃整粒坚果、爆米花、硬糖。",
    "fridge.baby.rules.9m.4": "吃饭时坐直，大人一直在旁边看着。",
    "fridge.baby.rules.1y.1": "可以吃切小的家常饭，但先单独盛出来再调味；尽量不放盐（1–3 岁每天不超过 2 克）。",
    "fridge.baby.rules.1y.2": "少糖，不喝含糖饮料和果汁；牛奶每天约 300–500 毫升。",
    "fridge.baby.rules.1y.3": "整粒坚果 5 岁前不要给；圆的小食物要切开。",
    "fridge.baby.rules.1y.4": "少吃香肠、火腿等加工肉和很咸的奶酪。",
    "fridge.baby.none": "食材库里还凑不出宝宝餐",
    "fridge.baby.noneSub": "放进一些蔬菜（胡萝卜、西兰花、土豆）、水果（香蕉、苹果）、鸡蛋、鱼或肉、大米或燕麦，这里就会推荐。",
    "fridge.baby.portion": "一次约 {g} 克",
    "fridge.baby.iron": "含铁",
    "fridge.baby.ironWhy": "肉、鱼、蛋含铁多。宝宝 6 个月后自身储存的铁快用完了，每天都要吃一点含铁的食物。",
    "fridge.baby.allergenShort": "含 {list}",
    "fridge.baby.allergens": "含常见过敏食物：{list}。第一次吃时只给一小勺，之后 2–3 天别加别的新食物，留意有没有皮疹、呕吐、腹泻。",
    "fridge.baby.allergen.egg": "鸡蛋",
    "fridge.baby.allergen.fish": "鱼",
    "fridge.baby.allergen.shellfish": "虾贝",
    "fridge.baby.allergen.milk": "奶",
    "fridge.baby.allergen.wheat": "小麦",
    "fridge.baby.allergen.soy": "大豆",
    "fridge.baby.allergen.peanut": "花生",
    "fridge.baby.avoid": "食材库里这些不适合给宝宝",
    "fridge.baby.why.honey": "1 岁前不能吃蜂蜜（可能引起婴儿肉毒杆菌中毒）",
    "fridge.baby.why.nuts": "整粒坚果容易噎住，可以用磨得很细的坚果酱",
    "fridge.baby.why.processed": "加工肉、腌制和熏制的食物太咸",
    "fridge.baby.why.junk": "太甜或太咸，不适合宝宝",
    "fridge.baby.why.seasoning": "1 岁前做饭不加调料",
    "fridge.baby.why.cheese": "太咸，1 岁后再少量吃",
    "fridge.baby.disclaimer": "以上是常见的辅食建议，不能代替医生的意见；宝宝有过敏、早产或其他特殊情况，请先问医生或儿保。",
    "fridge.baby.back": "看其他宝宝餐",
    "fridge.baby.raw": "直接压泥",
    "fridge.baby.steamFirst": "先蒸软",
    "fridge.baby.quarters": "一定要切成四瓣",
    "fridge.baby.dish.vegPuree": "{main}泥",
    "fridge.baby.dish.fruitPuree": "{main}泥",
    "fridge.baby.dish.porridge": "{main}糊",
    "fridge.baby.dish.proteinPuree": "{all}泥",
    "fridge.baby.dish.eggMash": "蛋黄泥",
    "fridge.baby.dish.congee": "{all}粥",
    "fridge.baby.dish.fingerVeg": "蒸{all}条（手指食物）",
    "fridge.baby.dish.omelette": "{others}蛋饼条",
    "fridge.baby.dish.pastaMince": "{all}软面",
    "fridge.baby.dish.fruitPieces": "{main}软块（手指食物）",
    "fridge.baby.dish.softRice": "{all}软饭",
    "fridge.baby.dish.eggNoodles": "{all}鸡蛋面",
    "fridge.baby.dish.meatballs": "{all}小丸子",
    "fridge.baby.steps.vegPuree.1": "{main}洗净去皮，切小块，蒸或煮到用勺子一压就烂（约 15–20 分钟）。",
    "fridge.baby.steps.vegPuree.2": "加一点煮菜的水、母乳或配方奶，用料理机打成很细的泥；不加盐和糖。",
    "fridge.baby.steps.vegPuree.3": "晾到温热再喂，从 1–2 小勺开始。吃不完的可以分格冷冻，一个月内吃完。",
    "fridge.baby.steps.fruitPuree.1": "{main}洗净，去皮去核。香蕉、牛油果、芒果可以直接压；苹果、梨先蒸 8–10 分钟。",
    "fridge.baby.steps.fruitPuree.2": "压成细泥，太稠就加一点母乳或配方奶。",
    "fridge.baby.steps.fruitPuree.3": "现做现吃，不加糖。",
    "fridge.baby.steps.porridge.1": "{main}加 8–10 倍的水（燕麦加 5 倍），小火煮到很烂。",
    "fridge.baby.steps.porridge.2": "用料理机打细，可以加{others}调稀（1 岁前牛奶不当饮料喝，做饭少量可以用）。",
    "fridge.baby.steps.porridge.3": "不加糖和盐，晾到温热再喂。",
    "fridge.baby.steps.proteinPuree.1": "{main}去皮去骨，鱼要仔细挑刺；切小块，煮或蒸到完全熟透，中间没有粉色。",
    "fridge.baby.steps.proteinPuree.2": "和{others}一起放进料理机，加一点煮的汤或水，打成细泥（9 个月以上可以留点小颗粒）。",
    "fridge.baby.steps.proteinPuree.3": "不加盐和酱油。一次吃不完的分格冷冻，一个月内吃完。",
    "fridge.baby.steps.eggMash.1": "鸡蛋冷水下锅，水开后再煮 10 分钟，一定要全熟。",
    "fridge.baby.steps.eggMash.2": "剥壳，先把蛋黄压成泥，加一点母乳、配方奶或温水调稀。",
    "fridge.baby.steps.eggMash.3": "蛋黄吃了几次没有不舒服，再试蛋白。",
    "fridge.baby.steps.congee.1": "{main}洗净，加 6–8 倍的水，小火煮成软烂的粥（约 40 分钟）。",
    "fridge.baby.steps.congee.2": "{others}剁成很碎的末（肉要全熟，鱼要挑刺），放进粥里再煮 10 分钟。",
    "fridge.baby.steps.congee.3": "用勺背压一压，留一点小颗粒练习咀嚼。不加盐。",
    "fridge.baby.steps.fingerVeg.1": "{all}切成手指粗、比宝宝的拳头长一点的条，或小朵。",
    "fridge.baby.steps.fingerVeg.2": "蒸到用手指一捏就烂（约 8–12 分钟），晾凉。",
    "fridge.baby.steps.fingerVeg.3": "让宝宝坐直，自己抓着吃，大人一直在旁边看着。",
    "fridge.baby.steps.omelette.1": "鸡蛋打散，{others}切成很碎的末拌进去，不放盐。",
    "fridge.baby.steps.omelette.2": "不粘锅抹一点点油，小火两面煎到完全凝固，没有流动的蛋液。",
    "fridge.baby.steps.omelette.3": "切成手指粗的条让宝宝自己抓着吃（1 岁以上可以切小块）。",
    "fridge.baby.steps.pastaMince.1": "{main}按包装时间多煮 2–3 分钟，煮软，剪成小段。",
    "fridge.baby.steps.pastaMince.2": "{others}剁碎，加一点水煮熟焖软（肉要全熟，鱼要挑刺）。",
    "fridge.baby.steps.pastaMince.3": "拌在一起；9–12 个月压碎一点，1 岁以上切小块。不加盐和酱油。",
    "fridge.baby.steps.fruitPieces.1": "{main}洗净，去皮去核，切成手指粗的条或软块；葡萄、蓝莓、小番茄一定要切成四瓣。",
    "fridge.baby.steps.fruitPieces.2": "太硬的（苹果、梨）先蒸 5 分钟变软。",
    "fridge.baby.steps.fruitPieces.3": "让宝宝坐直自己抓着吃，大人在旁边看着。",
    "fridge.baby.steps.softRice.1": "{main}多加一点水，煮成软饭。",
    "fridge.baby.steps.softRice.2": "{others}切成小丁（约 1 厘米），蒸熟或煮熟；肉要全熟，鱼要挑刺。",
    "fridge.baby.steps.softRice.3": "和软饭拌在一起，尽量不放盐，可以用番茄、洋葱的味道提味。",
    "fridge.baby.steps.eggNoodles.1": "面条煮软，剪成小段。",
    "fridge.baby.steps.eggNoodles.2": "{others}切碎，用少许油炒软，鸡蛋打散倒进去炒到全熟。",
    "fridge.baby.steps.eggNoodles.3": "和面拌在一起；不放盐和酱油，番茄的酸甜就够有味道了。",
    "fridge.baby.steps.meatballs.1": "{main}剁成细末（鱼要挑干净刺），{others}切得很碎，拌在一起，可以加一点燕麦。",
    "fridge.baby.steps.meatballs.2": "搓成小丸子，蒸 15 分钟，或煮到完全熟透。",
    "fridge.baby.steps.meatballs.3": "压扁或切成两半再给宝宝；不放盐。",
    "fridge.health.label": "按身体状况挑：",
    "fridge.health.all": "全部",
    "fridge.health.weight": "减脂",
    "fridge.health.sugar": "控糖",
    "fridge.health.salt": "控盐",
    "fridge.health.fromGoal": "按你在“饮食 › 目标”里的设置：{goal}。",
    "fridge.health.noGoal": "在“饮食 › 目标”里设好身体状况，这里会自动按它挑。",
    "fridge.health.limits": "每人这一餐最好不超过：热量 {kcal} 千卡 · 糖 {sugar} 克 · 碳水 {carbs} 克 · 盐 {salt} 克",
    "fridge.health.per": "每人约 {kcal} 千卡 · 糖 {sugar} 克 · 盐 {salt} 克",
    "fridge.health.perLong": "每人约：热量 {kcal} 千卡 · 蛋白质 {protein} 克 · 脂肪 {fat} 克 · 碳水 {carbs} 克 · 糖 {sugar} 克 · 盐 {salt} 克",
    "fridge.health.partial": "有的食材没有营养数据，实际数值会高一点。",
    "fridge.health.tip.lessSalt": "健康做法：盐和酱油只放一半，可以多用葱姜蒜、柠檬、醋提味。",
    "fridge.health.tip.lessOil": "健康做法：油只放一半，用不粘锅或蒸、煮代替炸。",
    "fridge.health.tip.noSugar": "健康做法：不另外加糖。",
    "fridge.health.none": "按“{goal}”，现在的食材里没有合适的菜。可以换个选项看看，或看下面的“健康一盘”。",
    "fridge.health.hidden": "另有 {n} 道不太适合“{goal}”，已经收起来。",
    "fridge.plate.title": "健康一盘：用现有食材搭配",
    "fridge.plate.sub": "一份瘦的蛋白质 + 蔬菜 + 定量主食，少油少盐，按你的身体状况算好分量。",
    "fridge.plate.name.steam": "清蒸{protein}配{veg}",
    "fridge.plate.name.egg": "{protein}炒{veg}",
    "fridge.plate.name.stirfry": "少油快炒{protein}配{veg}",
    "fridge.plate.withStaple": "{dish}，主食{staple}",
    "fridge.plate.another": "换一个搭配",
    "fridge.plate.see": "看做法",
    "fridge.plate.none": "食材库里还要有一样蛋白质（鱼、虾、鸡肉、鸡蛋、豆腐等）和一样蔬菜，才能搭出健康一盘。",
    "fridge.plate.steam.1": "{protein}洗净摆盘，有姜、葱就铺在上面，水开后大火蒸 8–12 分钟（虾 5 分钟）。",
    "fridge.plate.egg.1": "鸡蛋打散，不放盐。锅里放一半的油，蛋液炒到刚凝固就盛出。",
    "fridge.plate.stirfry.1": "{protein}切小块或薄片。锅烧热放一半的油，大火炒到全熟后盛出。",
    "fridge.plate.veg": "{veg}洗净切好，用一点油快炒 2–3 分钟，或在开水里焯 1–2 分钟，保持脆绿。",
    "fridge.plate.season": "出锅前只淋 {soy} 克酱油（约 {spoons} 小勺），不另外放盐；有蒜、柠檬可以加一点提味。",
    "fridge.plate.staple": "{staple}每人 {g} 克（生重）煮熟，不要再多盛。",
    "fridge.plate.order": "吃的时候先吃蔬菜和{protein}，最后吃主食，饭后血糖更平稳。",
    "fridge.cook.seeDay": "看今天的情况",
    "fridge.cook.keep": "存为我家的菜谱（下次家里有这些食材时会推荐）",
    "fridge.add.price": "多少钱（可选）",
    "fridge.add.priceHint": "没有小票时填上，会记进账本的“买的食材（无小票）”。",
    "fridge.add.booked": "已记进账本 {amount}",
    "fridge.receipt.title": "把小票上的食品放进食材库",
    "fridge.receipt.pick": "选一张小票",
    "fridge.receipt.noRecords": "没有还没放进食材库的小票了。",
    "fridge.receipt.hint": "已自动去掉押金、购物袋和日用品。分类是自动猜的，点一下可以改。",
    "fridge.receipt.none": "这张小票上没有可以放进食材库的食品。",
    "fridge.receipt.save": "放进食材库（{n} 样）",
    "fridge.receipt.done": "新放进 {added} 样，{merged} 样增加了数量",

    "fridge.cook.title": "做一道菜",
    "fridge.cook.name": "菜名",
    "fridge.cook.namePh": "例如：番茄意面",
    "fridge.cook.pick": "用了食材库里的哪些食材？",
    "fridge.cook.basics": "调料（盐、油是精确计算的关键）",
    "fridge.cook.basic.salt": "盐",
    "fridge.cook.basic.sugar": "糖",
    "fridge.cook.basic.oil": "食用油",
    "fridge.cook.basic.butter": "黄油",
    "fridge.cook.basic.soySauce": "酱油",
    "fridge.cook.spoon": "1 勺 ≈ {g} g",
    "fridge.cook.grams": "克",
    "fridge.cook.half": "半{unit}",
    "fridge.cook.whole": "整{unit}",
    "fridge.cook.servings": "做了几份",
    "fridge.cook.eat": "我吃了几份",
    "fridge.cook.perServing": "每份营养（按食材精确计算）",
    "fridge.cook.estimated": "按一般营养值估算：{names}（扫条形码或拍营养表会更准）",
    "fridge.cook.missing": "{names} 没有营养数据，没算进去",
    "fridge.cook.deduct": "从食材库扣掉用掉的量",
    "fridge.cook.save": "记入今天的{meal}",
    "fridge.cook.saveOnly": "只扣库存，不记饮食",
    "fridge.cook.saved": "已记入：{name}，每份 {kcal} kcal",
    "fridge.cook.listed": "{names} 用完了，已加入购物清单",
    "fridge.cook.empty": "食材库里还没有带营养数据的食材。先扫几样常用的吧。",
    "fridge.cook.remove": "移除",
  },
  en: {
    "fridge.life.title": "Keeping time",
    "fridge.life.tipsTitle": "Tips for photographing the date",
    "fridge.life.tipWhere": "Aim at where the date is printed: the lid, the side or the bottom",
    "fridge.life.tipSharp": "Good light, come close, wait until it's sharp",
    "fridge.life.tipMore": "If it says “after opening, use within…”, “keep refrigerated” or “keep frozen”, get that in too",
    "fridge.life.photo": "Photo of the date on the pack",
    "fridge.life.photoBtn": "Photo the date",
    "fridge.life.readFail": "Couldn't read a date. Try again a little closer, or type the date yourself.",
    "fridge.life.readUseBy": "Use by {date}",
    "fridge.life.readBest": "Best before {date}",
    "fridge.life.readOpen": "after opening: {n} days",
    "fridge.life.store.fridge": "keep in the fridge",
    "fridge.life.store.freezer": "keep frozen",
    "fridge.life.store.room": "cool, dry place",
    "fridge.life.noFreeze": "do not freeze",
    "fridge.life.readDone": "Found: {what}",
    "fridge.life.kind": "Kind of date",
    "fridge.life.use_by": "Use by",
    "fridge.life.best_before": "Best before",
    "fridge.life.use_byMeans": "Not safe after it (fresh meat, fish, milk)",
    "fridge.life.best_beforeMeans": "After it: look and smell first, often still fine",
    "fridge.life.noDate": "No date yet. Photograph the date on the pack, or type it.",
    "fridge.life.leftUseBy": "Use by {date}: {n} days left",
    "fridge.life.leftBest": "Best before {date}: {n} days left",
    "fridge.life.todayUseBy": "Use by today: eat it today or freeze it now",
    "fridge.life.todayBest": "Best before today",
    "fridge.life.pastUseBy": "{n} days past its use-by date: don't eat it, throw it away",
    "fridge.life.pastBest": "{n} days past best before",
    "fridge.life.checkHow": "Look, smell, taste a little: if colour, smell and taste are normal, eat it soon; mould, a swollen pack or an odd smell means throw it away.",
    "fridge.life.expiredHow": "Freezing can't save it now: please throw it away.",
    "fridge.life.barLabel": "{pct}% of its keeping time has passed",
    "fridge.life.bought": "Bought {date}",
    "fridge.life.opened": "Opened {date}",
    "fridge.life.frozen": "Frozen {date}",
    "fridge.life.frozenLeft": "🧊 In the freezer: best eaten by {date} ({n} days)",
    "fridge.life.frozenPast": "🧊 {n} days past the freezer guide: still safe, but quality fades, eat it soon",
    "fridge.life.openBtn": "Opened today (eat within {n} days)",
    "fridge.life.freezeBtn": "Into the freezer (about {n} months)",
    "fridge.life.thawBtn": "Thawed (eat within 1 day, don't refreeze)",
    "fridge.life.editDate": "Change date",
    "fridge.life.openDays": "Days it keeps once opened",
    "fridge.life.greenBin": "Throw it away green: the food goes in the food-waste bin, the rinsed packaging into plastic, paper or glass recycling.",
    "fridge.pastBest": "{n} days past best",
    "fridge.focus.check": "Past best before: check them",
    "fridge.note.checkOne": "{name} is {n} days past its best-before date. Look and smell: if it's fine, eat it soon rather than waste it.",
    "fridge.note.frozenPast": "{name} has been in the freezer longer than advised: still safe, but eat it this week before it loses its taste.",
    "fridge.note.frozenSoon": "{name} keeps {n} more days in the freezer: plan a meal with it.",
    "fridge.note.orFreeze": "Can't finish it? Freeze it today and it keeps for months.",
    "fridge.board.sumCheck": "{n} to check",
    "fridge.note.expiredOne": "{name} is {n} days past its use-by date. Please throw it away, don't eat it.",
    "fridge.item.deleteStock": "There is still stock: if it was thrown away, use “Throw away” instead, so it counts in the monthly waste and cost.",
    "fridge.cook.deductEstimated": "{names}: no pack size, so a usual amount was taken off the pantry — check what's left there.",
    "fridge.energy.f.phoneExtra": "Logged workouts beyond the watch's figure = {v} kcal (exercise it didn't record)",
    "fridge.energy.f.exerciseNoWalk": "Other exercise (walks are already in the steps) = {v} kcal",
    "fridge.energy.f.phoneActive": "Active calories from the phone/watch = {v} kcal (walking and workouts it measured are included)",
    "fridge.item.labelPhoto": "Photo of the nutrition table (tap to enlarge)",
    "fridge.labelPhoto.title": "Nutrition table: {name}",
    "fridge.labelPhoto.save": "Save to the pantry",
    "fridge.energy.f.phoneBase": "Resting and digesting = resting burn {bmr} × 1.1 = {v} kcal",
    "fridge.energy.f.stepsBase": "Sitting baseline = resting burn {bmr} × 1.2 = {v} kcal",
    "fridge.energy.f.steps": "Walking = {steps} steps × 0.00057 × weight {w} = {v} kcal (about 0.04 kcal a step)",
    "fridge.energy.f.total": "Burned today = {parts} = {v} kcal",
    "fridge.energy.act2.title": "Today's steps and activity",
    "fridge.energy.act2.hint": "Look up today's steps in Health (iPhone) or Google Fit / Samsung Health (Android) and fill them in; you can also add the active calories your watch or gym machine shows. Active calories, when filled in, count instead (walking and workouts are in them — nothing is counted twice).",
    "fridge.energy.act2.steps": "Steps",
    "fridge.energy.act2.active": "Active calories (kcal, optional)",
    "fridge.energy.act2.save": "Save today's activity",
    "fridge.energy.act2.invalid": "Steps 0–100,000 and active calories 0–5,000 kcal, please.",
    "fridge.energy.act2.fromPhone": "Today's figures came from your phone's automatic sync.",
    "fridge.energy.sync.title": "iPhone: sync automatically every day (Shortcuts)",
    "fridge.energy.sync.last": "last synced {when}",
    "fridge.energy.sync.intro": "With the iPhone's own Shortcuts app, your steps and active calories from Health go to NutriCart by themselves every evening. Set it up once.",
    "fridge.energy.sync.makeLink": "Make my sync link",
    "fridge.energy.sync.newLink": "Make a new sync link (the old one stops working)",
    "fridge.energy.sync.copy": "Copy link",
    "fridge.energy.sync.copied": "Copied",
    "fridge.energy.sync.step1": "Tap “Make my sync link”, then “Copy link”. The link is yours alone — don't share it.",
    "fridge.energy.sync.step2": "Open the Shortcuts app → Automation (bottom) → “+” (top right) → Time of Day, every day at 21:30, “Run Immediately”, Next.",
    "fridge.energy.sync.step3": "Choose New Blank Automation, add the action “Find Health Samples”: type Steps, start date Today; then add “Calculate Statistics”, Sum.",
    "fridge.energy.sync.step4": "Add “Find Health Samples” again with type Active Energy, start date Today, then “Calculate Statistics”, Sum.",
    "fridge.energy.sync.step5": "Add “Get Contents of URL”: paste your sync link, method POST, request body JSON with two fields: steps = the first Statistics, activeKcal = the second Statistics.",
    "fridge.energy.sync.step6": "Tap Done. Run it once by hand to try; come back here — when it says the figures came from your phone, it works. (Names can differ slightly between iOS versions.)",
    "fridge.energy.sync.android": "Android: for now please fill in your steps by hand each day (a quick look in Google Fit or Samsung Health — 10 seconds).",
    "fridge.add.noNumbers": "Found “{name}”, but the open database has no nutrition for it yet. Take a photo of the nutrition table and it’s read right away — and remembered for anyone who scans this barcode later.",
    "fridge.board.sign": "— with love, your pantry",
    "fridge.note.lowListed": "{names} ran out — I’ve already put it on your shopping list 🛒",
    "fridge.note.lowRemind": "{names} is running low; remember to restock.",
    "fridge.note.andMore": "{names} and {n} in all",
    "fridge.board.sumExpired": "{n} past date",
    "fridge.board.sumSoon": "{n} due soon",
    "fridge.board.sumLow": "{n} to buy",
    "fridge.board.page": "Page {n} of {total}",
    "fridge.board.prev": "Previous",
    "fridge.board.next": "Next",
    "fridge.board.pages": "Pages",
    "fridge.board.title": "Today's notes",
    "fridge.note.soonToday": "{name} is due today — enjoy it today so nothing goes to waste.",
    "fridge.note.soonOne": "{name} is due in {n} days. Eat it first?",
    "fridge.note.allGood": "Everything is fresh and well stocked. Eat well today 💚",
    "fridge.note.look": "Show me",
    "fridge.seeAll": "See all {n} items",
    "fridge.backToShelves": "All shelves",
    "fridge.focus.expired": "Past the date: throw away",
    "fridge.focus.soon": "Due soon: eat these first",
    "fridge.focus.low": "Time to restock",
    "fridge.allItems": "Everything",
    "fridge.shelfEmpty": "Nothing here yet. Add something with the button below.",
    "fridge.item.throwNow": "For your health, throw it away",
    "fridge.until": "until {date}",
    "fridge.short.carbs": "Carbs",
    "fridge.short.sugar": "Sugar",
    "fridge.short.fat": "Fat",
    "fridge.short.salt": "Salt",
    "fridge.title": "Pantry",
    "fridge.search": "Search food",
    "fridge.all": "All",
    "fridge.cat.staples": "Staples",
    "fridge.cat.produce": "Fruit & veg",
    "fridge.cat.protein": "Meat, fish, eggs",
    "fridge.cat.dairy": "Dairy",
    "fridge.cat.frozen": "Frozen",
    "fridge.cat.drinks": "Drinks",
    "fridge.cat.condiments": "Condiments",
    "fridge.cat.snacks": "Snacks",
    "fridge.cat.other": "Other",
    "fridge.unit.pack": "pack",
    "fridge.unit.bottle": "bottle",
    "fridge.unit.piece": "piece",
    "fridge.add": "Add to pantry",
    "fridge.cook": "Cook a dish",
    "fridge.emptyTitle": "The pantry is empty",
    "fridge.emptyBody": "Scan the barcode on a pack: name, nutrition, pack size and a use-by date are filled in for you. Or add the food from a receipt in one go.",
    "fridge.noMatch": "Nothing matches.",
    "fridge.per100g": "per 100 g",
    "fridge.per100ml": "per 100 ml",
    "fridge.noNutrition": "No nutrition yet",
    "fridge.expiresIn": "Use within {n} days",
    "fridge.expiresToday": "Use today",
    "fridge.expiredAgo": "{n} days past",
    "fridge.noDate": "No date",
    "fridge.estimated": "estimated",
    "fridge.out": "Used up",
    "fridge.export": "Export to Excel",
    "fridge.exported": "Spreadsheet downloaded",
    "fridge.listAdded": "{name} is running low: added to the shopping list",
    "fridge.intoFridge": "In the pantry: {name}",

    "fridge.item.left": "How much is left",
    "fridge.item.expires": "Use by",
    "fridge.item.estimatedNote": "This date is a guess from the shelf; please use the date on the pack.",
    "fridge.item.nutrition": "Nutrition ({basis})",
    "fridge.item.fill": "Add the nutrition",
    "fridge.item.typical": "≈ are typical values for this food, as a guide; scan the barcode or photograph the nutrition table for the exact ones.",
    "fridge.item.fillExact": "Want exact values? Scan the barcode or photograph the label:",
    "fridge.item.scan": "Scan barcode",
    "fridge.item.label": "Photo of the label",
    "fridge.item.restock": "Restock reminder",
    "fridge.item.restockLine": "At {min} {unit} or less, put {qty} {unit} on the shopping list",
    "fridge.item.minQty": "Remind me at",
    "fridge.item.restockQty": "Buy",
    "fridge.item.auto": "Add to the shopping list automatically",
    "fridge.item.details": "Shelf, unit and pack",
    "fridge.item.shelf": "Shelf",
    "fridge.item.unit": "Unit",
    "fridge.item.packSize": "Grams or ml per {unit}",
    "fridge.item.packHint": "Needed to take grams used in cooking off the stock",
    "fridge.item.discard": "Throw away (spoilt or past date)",
    "fridge.item.discarded": "Thrown away: {name}",
    "fridge.item.delete": "Stop keeping this",
    "fridge.item.deleteTitle": "Remove “{name}” from the pantry?",
    "fridge.item.deleteBody": "Its nutrition and restock reminder go too. If it's just used up, keep it: at 0 you'll be reminded to buy more.",
    "fridge.item.deleted": "Removed",

    "fridge.add.title": "Add to pantry",
    "fridge.add.scan": "Scan barcode",
    "fridge.add.scanSub": "Best: name, nutrition and pack size filled in",
    "fridge.add.receipt": "From a receipt",
    "fridge.add.receiptSub": "Photograph a new receipt or pick one not added yet: budget and pantry in one go",
    "fridge.add.type": "Type a name",
    "fridge.add.typeSub": "Fruit, veg and loose food without a barcode",
    "fridge.add.name": "Name",
    "fridge.add.namePh": "e.g. Tomatoes",
    "fridge.add.qty": "Quantity",
    "fridge.add.found": "Found",
    "fridge.add.notFound": "This product isn't in the database. Type the name and take a photo of the label.",
    "fridge.add.labelBtn": "Photo of the label: read the nutrition",
    "fridge.add.reading": "Reading the label… {pct}%",
    "fridge.add.labelRead": "Nutrition read — please check it",
    "fridge.add.labelFail": "Couldn't read it. Add it now and fill in the nutrition later.",
    "fridge.add.save": "Add to pantry",
    "fridge.add.merged": "Already in the pantry: +{n}",
    "fridge.add.again": "Scan another",
    "fridge.exp.d3": "3 days",
    "fridge.exp.w1": "1 week",
    "fridge.exp.w2": "2 weeks",
    "fridge.exp.m1": "1 month",
    "fridge.exp.m3": "3 months",
    "fridge.exp.m6": "6 months",
    "fridge.exp.y1": "1 year",
    "fridge.exp.hint": "Use the date on the pack. Left empty, the app estimates one from the shelf.",

    "fridge.receipt.button": "Add to pantry",
    "fridge.receipt.skip": "Not now",
    "fridge.item.bought": "Bought at {store} · {date}{price} · see receipt",
    "fridge.receipt.newPhoto": "Photograph a new receipt (budget and pantry in one go)",
    "fridge.recipe.title": "What can I cook?",
    "fridge.recipe.card": "You can cook with what you have",
    "fridge.recipe.ask": "Not sure what to make? See dishes you can cook with what's here",
    "fridge.recipe.intro": "Everyday dishes picked from what's in your pantry, using up what's about to go off first.",
    "fridge.recipe.none": "Not enough for a dish yet",
    "fridge.recipe.noneSub": "Add a few everyday foods (eggs, tomatoes, potatoes, fish, meat) and suggestions appear here.",
    "fridge.recipe.usesUp": "uses up {names}",
    "fridge.recipe.allHere": "you have everything",
    "fridge.recipe.missing": "missing {names}",
    "fridge.recipe.back": "Other dishes",
    "fridge.recipe.minutes": "About {n} minutes",
    "fridge.recipe.ingredients": "Ingredients",
    "fridge.recipe.optional": "optional",
    "fridge.recipe.notHome": "not at home",
    "fridge.recipe.basics": "Seasoning: {names}",
    "fridge.recipe.steps": "How to make it",
    "fridge.recipe.cookHint": "“Cook this” fills in the ingredients and amounts, works out calories, sugar and salt per serving, and takes what you use off the pantry.",
    "fridge.recipe.cook": "Cook this",
    "fridge.recipe.buy": "Put the {n} missing on the list",
    "fridge.recipe.listed": "{n} added to the shopping list",
    "fridge.cuisine.chinese": "Chinese",
    "fridge.cuisine.dutch": "Dutch",
    "fridge.cuisine.italian": "Italian",
    "fridge.cuisine.french": "French",
    "fridge.cuisine.german": "German",
    "fridge.cuisine.czech": "Czech",
    "fridge.cuisine.spanish": "Spanish",
    "fridge.cuisine.indonesian": "Indonesian / Surinamese",
    "fridge.cuisine.turkish": "Turkish / Moroccan",
    "fridge.cuisine.indian": "Indian",
    "fridge.cuisine.korean": "Korean",
    "fridge.cuisine.japanese": "Japanese",
    "fridge.cuisine.western": "Everyday western",
    "fridge.recipe.likedNow": "First: {names}",
    "fridge.recipe.likedAll": "All kitchens (tap to choose favourites)",
    "fridge.recipe.likedHint": "Choose the kitchens your household likes (as many as you want); suggestions show these first. Choose none to see everything.",
    "fridge.recipe.ours": "Our own dishes",
    "fridge.recipe.oursSub": "Your household has made this {n} times.",
    "fridge.recipe.forYou": "From your favourite kitchens",
    "fridge.recipe.others": "Other kitchens",
    "fridge.recipe.showOthers": "See other kitchens ({n})",
    "fridge.recipe.cookedTimes": "made {n}×",
    "fridge.recipe.forget": "Stop suggesting this dish",
    "fridge.recipe.forgotten": "“{name}” won’t be suggested again",
    "fridge.energy.open": "Today's energy balance",
    "fridge.energy.openSub": "Eaten − burned, against your own health standard",
    "fridge.energy.title": "Today's energy balance",
    "fridge.energy.diffTitle": "Today's balance (eaten − burned)",
    "fridge.energy.deficit": "A deficit today: you burned more than you ate — about {kg} kg of body fat.",
    "fridge.energy.surplus": "A surplus today: you ate more than you burned — about {kg} kg of body fat stored.",
    "fridge.energy.even": "Eaten and burned are about even today: your weight stays.",
    "fridge.energy.formula": "The formula, in your numbers",
    "fridge.energy.f.bmr": "Resting burn (Mifflin–St Jeor) = 10 × weight {w} + 6.25 × height {h} − 5 × age {a} {s} = {v} kcal",
    "fridge.energy.f.life": "Daily life = resting burn {bmr} × activity factor {f} ({act}) = {v} kcal",
    "fridge.energy.f.exercise": "Exercise logged today = {v} kcal ({min} min)",
    "fridge.energy.f.burned": "Burned today = {life} + {ex} = {v} kcal",
    "fridge.energy.f.calib": "Personal correction = {v} kcal (from your weight change)",
    "fridge.energy.f.burnedCal": "Burned today = {life} + {ex} + ({calib}) = {v} kcal",
    "fridge.energy.cal.title": "Against your real weight",
    "fridge.energy.cal.notYet": "Needs at least 2 weeks with meals logged on most days and two weighings at least 14 days apart.",
    "fridge.energy.cal.compare": "Last {days} days ({logged} with meals logged): the formula predicts {pred} kg, your weight changed {act} kg.",
    "fridge.energy.cal.fits": "The formula fits your body well: no correction needed.",
    "fridge.energy.cal.more": "Your body burns about {v} kcal a day more than the formula says.",
    "fridge.energy.cal.less": "Your body burns about {v} kcal a day less than the formula says (or some meals weren't logged).",
    "fridge.energy.cal.apply": "Correct it from real life ({v} kcal a day)",
    "fridge.energy.cal.clear": "Remove the correction (now {v} kcal)",
    "fridge.energy.f.eaten": "Eaten today = {v} kcal ({n} things logged)",
    "fridge.energy.f.diff": "Balance = eaten {eaten} − burned {burned} = {v} kcal ≈ {kg} kg of body fat ({per} kcal ≈ 1 kg)",
    "fridge.energy.standard": "Against my health standard",
    "fridge.energy.goal.own": "Calorie standard: your own {v} kcal a day.",
    "fridge.energy.goal.slim": "Calorie standard (slimming): burned {burned} − {d} = {v} kcal.",
    "fridge.energy.goal.keep": "Calorie standard (keeping your weight): what you burn, {v} kcal.",
    "fridge.energy.left": "{v} kcal left for today.",
    "fridge.energy.over": "{v} kcal over today.",
    "fridge.energy.sugar": "Sugar: {v} g today / limit {max} g",
    "fridge.energy.salt": "Salt: {v} g today / limit {max} g",
    "fridge.energy.bmi": "BMI = weight {w} ÷ height {h}² = {v} ({band}; 18.5–24.9 is healthy)",
    "fridge.energy.band.under": "underweight",
    "fridge.energy.band.normal": "healthy",
    "fridge.energy.band.over": "overweight",
    "fridge.energy.band.obese": "obese",
    "fridge.energy.note": "Until the day is over, what you eat and do still changes this — it's most accurate after dinner. These are estimates, not medical advice; change your sugar, salt and calorie limits under Meals › Goals.",
    "fridge.energy.toMeals": "Log meals and exercise",
    "fridge.energy.editBody": "Edit body details",
    "fridge.energy.form.intro": "Working out what you burn needs these; they're only used for the sums and never shown to anyone.",
    "fridge.energy.form.sex": "Sex",
    "fridge.energy.form.year": "Year of birth",
    "fridge.energy.form.height": "Height (cm)",
    "fridge.energy.form.weight": "Weight now (kg)",
    "fridge.energy.form.weightFrom": "Latest in your weight log: {date}",
    "fridge.energy.form.activity": "Everyday activity (not counting exercise you log)",
    "fridge.energy.form.save": "Save and calculate",
    "fridge.energy.form.invalid": "Please fill in everything: year of birth, height 80–250 cm, weight 20–400 kg, and choose sex and activity.",
    "fridge.energy.sex.female": "Female",
    "fridge.energy.sex.male": "Male",
    "fridge.energy.act.sedentary": "Sitting",
    "fridge.energy.act.light": "Lightly active",
    "fridge.energy.act.moderate": "Moderately active",
    "fridge.energy.act.active": "Active",
    "fridge.energy.act.very": "Very active",
    "fridge.energy.actHint.sedentary": "Mostly sitting, little walking",
    "fridge.energy.actHint.light": "Desk work, some walking and housework every day",
    "fridge.energy.actHint.moderate": "Often standing or walking, e.g. shop work, young children",
    "fridge.energy.actHint.active": "Physical work, or exercise every day",
    "fridge.energy.actHint.very": "Heavy physical work, or hard training every day",
    "fridge.baby.open": "Cook for the little one",
    "fridge.baby.openSub": "Baby food from what's here, by age",
    "fridge.baby.title": "What to cook for the little one?",
    "fridge.baby.intro": "Baby and toddler food by age, from what's in your pantry — what's going off soon first.",
    "fridge.baby.ageLabel": "How old",
    "fridge.baby.age.6m": "6–8 months (purées)",
    "fridge.baby.age.9m": "9–12 months (mashed, finger food)",
    "fridge.baby.age.1y": "1–3 years (small family meals)",
    "fridge.baby.rulesTitle": "Good to know at this age",
    "fridge.baby.rules.6m.1": "Start solids at 6 months; breast milk or formula is still the main food.",
    "fridge.baby.rules.6m.2": "No salt, sugar, soy sauce or stock cubes — and never honey before age 1.",
    "fridge.baby.rules.6m.3": "One new food at a time, then wait 3 days before the next.",
    "fridge.baby.rules.6m.4": "Start with smooth purées, 1–2 teaspoons; meat, fish and eggs always cooked through.",
    "fridge.baby.rules.9m.1": "Move from purées to mashed and soft pieces, to learn chewing and eating by hand.",
    "fridge.baby.rules.9m.2": "Still no salt, sugar or honey; some iron-rich meat, fish or egg every day.",
    "fridge.baby.rules.9m.3": "Cut grapes, blueberries and cherry tomatoes in quarters; no whole nuts, popcorn or hard sweets.",
    "fridge.baby.rules.9m.4": "Always sitting upright, with an adult watching.",
    "fridge.baby.rules.1y.1": "Small, chopped family meals — take the child's portion out before seasoning; as little salt as possible (under 2 g a day at 1–3).",
    "fridge.baby.rules.1y.2": "Little sugar, no sweet drinks or juice; about 300–500 ml of milk a day.",
    "fridge.baby.rules.1y.3": "No whole nuts before age 5; cut small round foods.",
    "fridge.baby.rules.1y.4": "Little sausage, ham or other processed meat, and no very salty cheese.",
    "fridge.baby.none": "Not enough for a baby meal yet",
    "fridge.baby.noneSub": "Add a few vegetables (carrot, broccoli, potato), fruit (banana, apple), eggs, fish or meat, rice or oats and dishes appear here.",
    "fridge.baby.portion": "about {g} g per meal",
    "fridge.baby.iron": "Iron",
    "fridge.baby.ironWhy": "Meat, fish and eggs are rich in iron. From 6 months a baby's own iron store runs low, so some iron-rich food every day matters.",
    "fridge.baby.allergenShort": "contains {list}",
    "fridge.baby.allergens": "Contains common allergens: {list}. The first time, give one small spoon and no other new foods for 2–3 days; watch for rash, vomiting or diarrhoea.",
    "fridge.baby.allergen.egg": "egg",
    "fridge.baby.allergen.fish": "fish",
    "fridge.baby.allergen.shellfish": "shellfish",
    "fridge.baby.allergen.milk": "milk",
    "fridge.baby.allergen.wheat": "wheat",
    "fridge.baby.allergen.soy": "soy",
    "fridge.baby.allergen.peanut": "peanut",
    "fridge.baby.avoid": "Not for the little one from your pantry",
    "fridge.baby.why.honey": "no honey before age 1 (risk of infant botulism)",
    "fridge.baby.why.nuts": "whole nuts are a choking risk; finely ground nut butter is fine",
    "fridge.baby.why.processed": "processed, cured and smoked food is too salty",
    "fridge.baby.why.junk": "too sweet or too salty for a child",
    "fridge.baby.why.seasoning": "no seasoning in food before age 1",
    "fridge.baby.why.cheese": "too salty; a little from age 1",
    "fridge.baby.disclaimer": "Common guidance for starting solids, not medical advice; for allergies, premature birth or other special needs, ask your doctor or child health clinic first.",
    "fridge.baby.back": "Other baby meals",
    "fridge.baby.raw": "mash raw",
    "fridge.baby.steamFirst": "steam soft first",
    "fridge.baby.quarters": "always cut in quarters",
    "fridge.baby.dish.vegPuree": "{main} purée",
    "fridge.baby.dish.fruitPuree": "{main} purée",
    "fridge.baby.dish.porridge": "{main} porridge",
    "fridge.baby.dish.proteinPuree": "{all} purée",
    "fridge.baby.dish.eggMash": "Mashed egg yolk",
    "fridge.baby.dish.congee": "Rice porridge with {all}",
    "fridge.baby.dish.fingerVeg": "Steamed {all} sticks (finger food)",
    "fridge.baby.dish.omelette": "Omelette fingers with {others}",
    "fridge.baby.dish.pastaMince": "Soft pasta with {all}",
    "fridge.baby.dish.fruitPieces": "Soft {main} pieces (finger food)",
    "fridge.baby.dish.softRice": "Soft rice with {all}",
    "fridge.baby.dish.eggNoodles": "Egg noodles with {all}",
    "fridge.baby.dish.meatballs": "Little balls of {all}",
    "fridge.baby.steps.vegPuree.1": "Wash and peel the {main}, cut small, and steam or boil until it squashes with a spoon (15–20 minutes).",
    "fridge.baby.steps.vegPuree.2": "Blend very smooth with a little cooking water, breast milk or formula; no salt or sugar.",
    "fridge.baby.steps.vegPuree.3": "Serve lukewarm, starting with 1–2 teaspoons. Freeze the rest in portions and use within a month.",
    "fridge.baby.steps.fruitPuree.1": "Wash, peel and core the {main}. Banana, avocado and mango mash raw; steam apple and pear 8–10 minutes first.",
    "fridge.baby.steps.fruitPuree.2": "Mash smooth; thin with a little breast milk or formula if needed.",
    "fridge.baby.steps.fruitPuree.3": "Make it fresh, with no sugar.",
    "fridge.baby.steps.porridge.1": "Cook the {main} in 8–10 times as much water (oats: 5 times) on low heat until very soft.",
    "fridge.baby.steps.porridge.2": "Blend smooth; thin with {others} if you like (milk isn't a drink before 1, but a little in cooking is fine).",
    "fridge.baby.steps.porridge.3": "No sugar or salt; serve lukewarm.",
    "fridge.baby.steps.proteinPuree.1": "Remove skin and bones from the {main} — check fish carefully for bones; cut small and boil or steam until cooked right through, no pink inside.",
    "fridge.baby.steps.proteinPuree.2": "Blend with the {others} and a little cooking liquid or water until smooth (from 9 months leave it a little lumpy).",
    "fridge.baby.steps.proteinPuree.3": "No salt or soy sauce. Freeze leftovers in portions and use within a month.",
    "fridge.baby.steps.eggMash.1": "Put the egg in cold water, bring to the boil and cook 10 more minutes — fully hard-boiled.",
    "fridge.baby.steps.eggMash.2": "Peel, mash the yolk first and thin with breast milk, formula or warm water.",
    "fridge.baby.steps.eggMash.3": "When the yolk has gone well a few times, try the white.",
    "fridge.baby.steps.congee.1": "Rinse the {main} and simmer in 6–8 times as much water to a soft porridge (about 40 minutes).",
    "fridge.baby.steps.congee.2": "Chop the {others} very finely (meat cooked through, fish without bones) and simmer 10 more minutes in the porridge.",
    "fridge.baby.steps.congee.3": "Press with a spoon, leaving small bits to practise chewing. No salt.",
    "fridge.baby.steps.fingerVeg.1": "Cut the {all} into finger-thick sticks a little longer than the child's fist, or small florets.",
    "fridge.baby.steps.fingerVeg.2": "Steam until soft enough to squash between your fingers (8–12 minutes); let cool.",
    "fridge.baby.steps.fingerVeg.3": "Let the child sit upright and eat by hand, with an adult watching.",
    "fridge.baby.steps.omelette.1": "Beat the egg and mix in the {others}, chopped very finely; no salt.",
    "fridge.baby.steps.omelette.2": "Wipe a non-stick pan with a drop of oil; cook on low heat on both sides until fully set, no runny egg.",
    "fridge.baby.steps.omelette.3": "Cut into finger-wide strips to eat by hand (small pieces from age 1).",
    "fridge.baby.steps.pastaMince.1": "Cook the {main} 2–3 minutes longer than the pack says, until soft; cut into short pieces.",
    "fridge.baby.steps.pastaMince.2": "Chop the {others} and simmer in a little water until cooked and soft (meat through, fish without bones).",
    "fridge.baby.steps.pastaMince.3": "Mix together; mash a little at 9–12 months, chop small from age 1. No salt or soy sauce.",
    "fridge.baby.steps.fruitPieces.1": "Wash, peel and core the {main}; cut into finger-thick strips or soft pieces — grapes, blueberries and cherry tomatoes always in quarters.",
    "fridge.baby.steps.fruitPieces.2": "Steam hard fruit (apple, pear) 5 minutes until soft.",
    "fridge.baby.steps.fruitPieces.3": "Let the child sit upright and eat by hand, with an adult watching.",
    "fridge.baby.steps.softRice.1": "Cook the {main} with extra water until soft.",
    "fridge.baby.steps.softRice.2": "Dice the {others} small (about 1 cm) and steam or boil until done; meat through, fish without bones.",
    "fridge.baby.steps.softRice.3": "Mix with the rice; as little salt as possible — tomato and onion give flavour.",
    "fridge.baby.steps.eggNoodles.1": "Cook the noodles soft and cut them short.",
    "fridge.baby.steps.eggNoodles.2": "Chop the {others}, soften in a little oil, add the beaten egg and cook until fully set.",
    "fridge.baby.steps.eggNoodles.3": "Mix with the noodles; no salt or soy sauce — tomato gives enough taste.",
    "fridge.baby.steps.meatballs.1": "Mince the {main} finely (fish carefully without bones), chop the {others} very small, mix, and add a few oats if you like.",
    "fridge.baby.steps.meatballs.2": "Roll small balls; steam 15 minutes or simmer until cooked right through.",
    "fridge.baby.steps.meatballs.3": "Flatten or halve before giving; no salt.",
    "fridge.health.label": "Pick for my health:",
    "fridge.health.all": "All",
    "fridge.health.weight": "Slimming",
    "fridge.health.sugar": "Low sugar",
    "fridge.health.salt": "Low salt",
    "fridge.health.fromGoal": "From your goal under Meals › Goals: {goal}.",
    "fridge.health.noGoal": "Set your health goal under Meals › Goals and dishes are picked for it here.",
    "fridge.health.limits": "Best per person for this meal: up to {kcal} kcal · {sugar} g sugar · {carbs} g carbs · {salt} g salt",
    "fridge.health.per": "per person about {kcal} kcal · sugar {sugar} g · salt {salt} g",
    "fridge.health.perLong": "Per person about: {kcal} kcal · protein {protein} g · fat {fat} g · carbs {carbs} g · sugar {sugar} g · salt {salt} g",
    "fridge.health.partial": "Some ingredients have no nutrition data, so the real values are a little higher.",
    "fridge.health.tip.lessSalt": "Healthier: half the salt and soy sauce — use garlic, ginger, spring onion, lemon or vinegar for flavour.",
    "fridge.health.tip.lessOil": "Healthier: half the oil; use a non-stick pan, or steam or boil instead of frying.",
    "fridge.health.tip.noSugar": "Healthier: no added sugar.",
    "fridge.health.none": "Nothing at home suits “{goal}” right now. Try another option, or see the healthy plate below.",
    "fridge.health.hidden": "{n} more dishes don't suit “{goal}” so well and are hidden.",
    "fridge.plate.title": "Healthy plate from what's here",
    "fridge.plate.sub": "Lean protein + vegetables + a measured portion of rice or potatoes, little oil and salt, sized for your goal.",
    "fridge.plate.name.steam": "Steamed {protein} with {veg}",
    "fridge.plate.name.egg": "{protein} stir-fried with {veg}",
    "fridge.plate.name.stirfry": "Light stir-fry of {protein} with {veg}",
    "fridge.plate.withStaple": "{dish}, with {staple}",
    "fridge.plate.another": "Another combination",
    "fridge.plate.see": "How to make it",
    "fridge.plate.none": "For a healthy plate the pantry needs one protein (fish, shrimp, chicken, eggs, tofu…) and one vegetable.",
    "fridge.plate.steam.1": "Rinse the {protein} and lay it on a plate, ginger and spring onion on top if you have them; steam 8–12 minutes over boiling water (shrimp 5).",
    "fridge.plate.egg.1": "Beat the eggs without salt. Heat half the oil and scramble until just set; take them out.",
    "fridge.plate.stirfry.1": "Cut the {protein} into small pieces. Heat half the oil and stir-fry on high until cooked through; take it out.",
    "fridge.plate.veg": "Wash and cut the {veg}; stir-fry 2–3 minutes in a little oil, or blanch 1–2 minutes in boiling water so it stays crisp.",
    "fridge.plate.season": "Finish with only {soy} g soy sauce (about {spoons} tsp) and no extra salt; a little garlic or lemon adds flavour.",
    "fridge.plate.staple": "Cook {g} g (uncooked) {staple} per person — and no second helping.",
    "fridge.plate.order": "Eat the vegetables and {protein} first and the {staple} last: blood sugar rises more gently.",
    "fridge.cook.seeDay": "See my day",
    "fridge.cook.keep": "Keep as one of our dishes (suggested again when these foods are home)",
    "fridge.add.price": "What it cost (optional)",
    "fridge.add.priceHint": "Without a receipt, fill it in: it goes into the budget under “Groceries (no receipt)”.",
    "fridge.add.booked": "{amount} added to the budget",
    "fridge.receipt.title": "Put the food from a receipt in the pantry",
    "fridge.receipt.pick": "Pick a receipt",
    "fridge.receipt.noRecords": "No receipts left that aren't in the pantry yet.",
    "fridge.receipt.hint": "Deposits, bags and household products are left out. Shelves are guessed; tap one to change it.",
    "fridge.receipt.none": "Nothing on this receipt goes in the pantry.",
    "fridge.receipt.save": "Add to pantry ({n})",
    "fridge.receipt.done": "{added} new, {merged} topped up",

    "fridge.cook.title": "Cook a dish",
    "fridge.cook.name": "Dish",
    "fridge.cook.namePh": "e.g. Tomato pasta",
    "fridge.cook.pick": "Which ingredients from the pantry?",
    "fridge.cook.basics": "Seasoning (salt and oil matter most)",
    "fridge.cook.basic.salt": "Salt",
    "fridge.cook.basic.sugar": "Sugar",
    "fridge.cook.basic.oil": "Cooking oil",
    "fridge.cook.basic.butter": "Butter",
    "fridge.cook.basic.soySauce": "Soy sauce",
    "fridge.cook.spoon": "1 spoon ≈ {g} g",
    "fridge.cook.grams": "g",
    "fridge.cook.half": "½ {unit}",
    "fridge.cook.whole": "1 {unit}",
    "fridge.cook.servings": "Servings made",
    "fridge.cook.eat": "Servings I ate",
    "fridge.cook.perServing": "Per serving (calculated from the ingredients)",
    "fridge.cook.estimated": "Estimated with typical values: {names} (scan the barcode or snap the label to be exact)",
    "fridge.cook.missing": "{names}: no nutrition, not counted",
    "fridge.cook.deduct": "Take what I used off the stock",
    "fridge.cook.save": "Log as today's {meal}",
    "fridge.cook.saveOnly": "Update stock only",
    "fridge.cook.saved": "Logged: {name}, {kcal} kcal per serving",
    "fridge.cook.listed": "{names} used up: added to the shopping list",
    "fridge.cook.empty": "No ingredients with nutrition yet. Scan a few you use often.",
    "fridge.cook.remove": "Remove",
  },
  nl: {
    "fridge.life.title": "Houdbaarheid",
    "fridge.life.tipsTitle": "Tips voor de foto van de datum",
    "fridge.life.tipWhere": "Richt op de plek van de datum: deksel, zijkant of onderkant",
    "fridge.life.tipSharp": "Goed licht, dichtbij, wacht tot het scherp is",
    "fridge.life.tipMore": "Staat er “na opening binnen … dagen”, “koel bewaren” of “diepvries” op? Neem dat ook mee",
    "fridge.life.photo": "Foto van de datum op de verpakking",
    "fridge.life.photoBtn": "Datum fotograferen",
    "fridge.life.readFail": "Geen datum gevonden. Probeer het iets dichterbij opnieuw, of vul de datum zelf in.",
    "fridge.life.readUseBy": "Te gebruiken tot {date}",
    "fridge.life.readBest": "Ten minste houdbaar tot {date}",
    "fridge.life.readOpen": "na opening: {n} dagen",
    "fridge.life.store.fridge": "koel bewaren",
    "fridge.life.store.freezer": "in de vriezer",
    "fridge.life.store.room": "koel en droog",
    "fridge.life.noFreeze": "niet invriezen",
    "fridge.life.readDone": "Gevonden: {what}",
    "fridge.life.kind": "Soort datum",
    "fridge.life.use_by": "Te gebruiken tot",
    "fridge.life.best_before": "Ten minste houdbaar tot",
    "fridge.life.use_byMeans": "Daarna niet meer eten (vers vlees, vis, melk)",
    "fridge.life.best_beforeMeans": "Daarna: eerst kijken en ruiken, vaak nog goed",
    "fridge.life.noDate": "Nog geen datum. Fotografeer de datum op de verpakking, of vul hem in.",
    "fridge.life.leftUseBy": "Te gebruiken tot {date}: nog {n} dagen",
    "fridge.life.leftBest": "Ten minste houdbaar tot {date}: nog {n} dagen",
    "fridge.life.todayUseBy": "Vandaag de laatste dag: vandaag opeten of nu invriezen",
    "fridge.life.todayBest": "Vandaag de laatste dag van ten minste houdbaar",
    "fridge.life.pastUseBy": "{n} dagen over de datum: niet meer eten, weggooien",
    "fridge.life.pastBest": "{n} dagen over ten minste houdbaar",
    "fridge.life.checkHow": "Kijk, ruik en proef een beetje: ziet, ruikt en smaakt het normaal, eet het dan snel op; schimmel, een bolle verpakking of een vreemde geur: weggooien.",
    "fridge.life.expiredHow": "Invriezen helpt nu niet meer: gooi het weg.",
    "fridge.life.barLabel": "{pct}% van de houdbaarheid is voorbij",
    "fridge.life.bought": "Gekocht {date}",
    "fridge.life.opened": "Geopend {date}",
    "fridge.life.frozen": "Ingevroren {date}",
    "fridge.life.frozenLeft": "🧊 In de vriezer: het lekkerst tot {date} (nog {n} dagen)",
    "fridge.life.frozenPast": "🧊 {n} dagen langer ingevroren dan aangeraden: nog veilig, maar minder lekker, eet het snel op",
    "fridge.life.openBtn": "Vandaag geopend (binnen {n} dagen op)",
    "fridge.life.freezeBtn": "In de vriezer (ongeveer {n} maanden)",
    "fridge.life.thawBtn": "Ontdooid (binnen 1 dag op, niet opnieuw invriezen)",
    "fridge.life.editDate": "Datum wijzigen",
    "fridge.life.openDays": "Dagen houdbaar na opening",
    "fridge.life.greenBin": "Gooi het milieuvriendelijk weg: het eten in de gft-bak, de omgespoelde verpakking bij plastic (PMD), papier of glas.",
    "fridge.pastBest": "{n} dagen over THT",
    "fridge.focus.check": "Over ten minste houdbaar: eerst controleren",
    "fridge.note.checkOne": "{name} is {n} dagen over ten minste houdbaar. Even kijken en ruiken: is het goed, eet het dan snel op, zonde om weg te gooien.",
    "fridge.note.frozenPast": "{name} ligt langer in de vriezer dan aangeraden: nog veilig, maar eet het deze week op.",
    "fridge.note.frozenSoon": "{name} kan nog {n} dagen in de vriezer: plan er een maaltijd mee.",
    "fridge.note.orFreeze": "Krijg je het niet op? Vries het vandaag in, dan blijft het maanden goed.",
    "fridge.board.sumCheck": "{n} controleren",
    "fridge.note.expiredOne": "{name} is al {n} dagen over de datum. Gooi het weg, niet meer opeten.",
    "fridge.item.deleteStock": "Er is nog voorraad: is het weggegooid, gebruik dan „Weggooien”, zodat het meetelt in de maandelijkse verspilling en kosten.",
    "fridge.cook.deductEstimated": "{names}: geen verpakkingsgewicht, dus een gebruikelijke hoeveelheid is van de voorraad afgehaald — controleer wat er over is.",
    "fridge.energy.f.phoneExtra": "Gelogde sport boven het horlogecijfer = {v} kcal (sport die het niet registreerde)",
    "fridge.energy.f.exerciseNoWalk": "Overige sport (wandelen zit al in de stappen) = {v} kcal",
    "fridge.energy.f.phoneActive": "Actieve calorieën van telefoon/horloge = {v} kcal (wandelen en gemeten sport zitten erin)",
    "fridge.item.labelPhoto": "Foto van de voedingstabel (tik om te vergroten)",
    "fridge.labelPhoto.title": "Voedingstabel: {name}",
    "fridge.labelPhoto.save": "Opslaan in de voorraad",
    "fridge.energy.f.phoneBase": "Rust en vertering = ruststofwisseling {bmr} × 1,1 = {v} kcal",
    "fridge.energy.f.stepsBase": "Zittende basis = ruststofwisseling {bmr} × 1,2 = {v} kcal",
    "fridge.energy.f.steps": "Lopen = {steps} stappen × 0,00057 × gewicht {w} = {v} kcal (ongeveer 0,04 kcal per stap)",
    "fridge.energy.f.total": "Verbruikt vandaag = {parts} = {v} kcal",
    "fridge.energy.act2.title": "Stappen en activiteit van vandaag",
    "fridge.energy.act2.hint": "Kijk je stappen van vandaag op in Gezondheid (iPhone) of Google Fit / Samsung Health (Android) en vul ze in; ook de actieve calorieën van je horloge of sporttoestel kunnen erbij. Ingevulde actieve calorieën tellen dan (lopen en sporten zitten erin — niets dubbel).",
    "fridge.energy.act2.steps": "Stappen",
    "fridge.energy.act2.active": "Actieve calorieën (kcal, mag leeg)",
    "fridge.energy.act2.save": "Activiteit van vandaag opslaan",
    "fridge.energy.act2.invalid": "Stappen 0–100.000 en actieve calorieën 0–5.000 kcal, graag.",
    "fridge.energy.act2.fromPhone": "De cijfers van vandaag komen van de automatische synchronisatie van je telefoon.",
    "fridge.energy.sync.title": "iPhone: elke dag automatisch synchroniseren (Opdrachten)",
    "fridge.energy.sync.last": "laatst gesynchroniseerd {when}",
    "fridge.energy.sync.intro": "Met de app Opdrachten van je iPhone gaan je stappen en actieve calorieën uit Gezondheid elke avond vanzelf naar NutriCart. Eén keer instellen.",
    "fridge.energy.sync.makeLink": "Mijn synchronisatielink maken",
    "fridge.energy.sync.newLink": "Nieuwe synchronisatielink maken (de oude werkt dan niet meer)",
    "fridge.energy.sync.copy": "Link kopiëren",
    "fridge.energy.sync.copied": "Gekopieerd",
    "fridge.energy.sync.step1": "Tik op „Mijn synchronisatielink maken” en dan „Link kopiëren”. De link is alleen van jou — deel hem niet.",
    "fridge.energy.sync.step2": "Open de app Opdrachten → Automatisering (onderaan) → „+” (rechtsboven) → Tijdstip, elke dag 21:30, „Voer direct uit”, Volgende.",
    "fridge.energy.sync.step3": "Kies Nieuwe lege automatisering, voeg de actie „Zoek gezondheidsgegevens” toe: type Stappen, begindatum Vandaag; voeg dan „Bereken statistieken” toe, Som.",
    "fridge.energy.sync.step4": "Voeg nog eens „Zoek gezondheidsgegevens” toe met type Actieve energie, begindatum Vandaag, en dan „Bereken statistieken”, Som.",
    "fridge.energy.sync.step5": "Voeg „Haal inhoud van URL op” toe: plak je synchronisatielink, methode POST, verzoekinhoud JSON met twee velden: steps = de eerste Statistieken, activeKcal = de tweede Statistieken.",
    "fridge.energy.sync.step6": "Tik op Gereed. Voer het één keer zelf uit om te proberen; kom hier terug — staat er dat de cijfers van je telefoon komen, dan werkt het. (Namen kunnen per iOS-versie iets verschillen.)",
    "fridge.energy.sync.android": "Android: vul je stappen voorlopig elke dag zelf in (even kijken in Google Fit of Samsung Health — 10 seconden).",
    "fridge.add.noNumbers": "“{name}” gevonden, maar de open database heeft nog geen voedingswaarden. Maak een foto van de voedingswaardetabel, dan wordt die meteen gelezen — en onthouden voor iedereen die deze code later scant.",
    "fridge.board.sign": "— liefs, je voorraad",
    "fridge.note.lowListed": "{names} is op — ik heb het al op je boodschappenlijstje gezet 🛒",
    "fridge.note.lowRemind": "{names} raakt op; denk aan bijkopen.",
    "fridge.note.andMore": "{names} en meer ({n})",
    "fridge.board.sumExpired": "{n} over datum",
    "fridge.board.sumSoon": "{n} moet snel op",
    "fridge.board.sumLow": "{n} kopen",
    "fridge.board.page": "Pagina {n} van {total}",
    "fridge.board.prev": "Vorige",
    "fridge.board.next": "Volgende",
    "fridge.board.pages": "Pagina’s",
    "fridge.board.title": "Briefjes van vandaag",
    "fridge.note.soonToday": "{name} moet vandaag op. Lekker vandaag eten, zonde om weg te gooien.",
    "fridge.note.soonOne": "{name} moet over {n} dagen op. Eerst dit eten?",
    "fridge.note.allGood": "Alles is vers en er is genoeg in huis. Eet smakelijk vandaag 💚",
    "fridge.note.look": "Bekijk",
    "fridge.seeAll": "Alle {n} items bekijken",
    "fridge.backToShelves": "Alle planken",
    "fridge.focus.expired": "Over datum: weggooien",
    "fridge.focus.soon": "Moet snel op: eerst eten",
    "fridge.focus.low": "Bijvullen",
    "fridge.allItems": "Alles",
    "fridge.shelfEmpty": "Hier ligt nog niets. Voeg iets toe met de knop hieronder.",
    "fridge.item.throwNow": "Voor je gezondheid: weggooien",
    "fridge.until": "tot {date}",
    "fridge.short.carbs": "Koolh.",
    "fridge.short.sugar": "Suiker",
    "fridge.short.fat": "Vet",
    "fridge.short.salt": "Zout",
    "fridge.title": "Voorraad",
    "fridge.search": "Zoek eten",
    "fridge.all": "Alles",
    "fridge.cat.staples": "Basis",
    "fridge.cat.produce": "Groente & fruit",
    "fridge.cat.protein": "Vlees, vis, eieren",
    "fridge.cat.dairy": "Zuivel",
    "fridge.cat.frozen": "Diepvries",
    "fridge.cat.drinks": "Dranken",
    "fridge.cat.condiments": "Kruiden & sauzen",
    "fridge.cat.snacks": "Snacks",
    "fridge.cat.other": "Overig",
    "fridge.unit.pack": "verp.",
    "fridge.unit.bottle": "fles",
    "fridge.unit.piece": "stuk",
    "fridge.add": "In de voorraad",
    "fridge.cook": "Iets koken",
    "fridge.emptyTitle": "De voorraad is leeg",
    "fridge.emptyBody": "Scan de streepjescode op een verpakking: naam, voedingswaarde, inhoud en houdbaarheid worden ingevuld. Of zet het eten van een bonnetje er in één keer in.",
    "fridge.noMatch": "Niets gevonden.",
    "fridge.per100g": "per 100 g",
    "fridge.per100ml": "per 100 ml",
    "fridge.noNutrition": "Nog geen voedingswaarde",
    "fridge.expiresIn": "Binnen {n} dagen op",
    "fridge.expiresToday": "Vandaag op",
    "fridge.expiredAgo": "{n} dagen over datum",
    "fridge.noDate": "Geen datum",
    "fridge.estimated": "geschat",
    "fridge.out": "Op",
    "fridge.export": "Exporteren naar Excel",
    "fridge.exported": "Spreadsheet gedownload",
    "fridge.listAdded": "{name} raakt op: op het boodschappenlijstje gezet",
    "fridge.intoFridge": "In de voorraad: {name}",

    "fridge.item.left": "Hoeveel is er nog",
    "fridge.item.expires": "Houdbaar tot",
    "fridge.item.estimatedNote": "Deze datum is geschat op basis van de plank; neem de datum van de verpakking over.",
    "fridge.item.nutrition": "Voedingswaarde ({basis})",
    "fridge.item.fill": "Voedingswaarde toevoegen",
    "fridge.item.typical": "≈ zijn gangbare waarden voor dit product, ter indicatie; scan de streepjescode of fotografeer de voedingstabel voor de precieze.",
    "fridge.item.fillExact": "Preciezer? Scan de streepjescode of fotografeer het etiket:",
    "fridge.item.scan": "Streepjescode scannen",
    "fridge.item.label": "Foto van het etiket",
    "fridge.item.restock": "Bijvulherinnering",
    "fridge.item.restockLine": "Bij {min} {unit} of minder: {qty} {unit} op het boodschappenlijstje",
    "fridge.item.minQty": "Herinner me bij",
    "fridge.item.restockQty": "Kopen",
    "fridge.item.auto": "Automatisch op het boodschappenlijstje",
    "fridge.item.details": "Plank, eenheid en verpakking",
    "fridge.item.shelf": "Plank",
    "fridge.item.unit": "Eenheid",
    "fridge.item.packSize": "Gram of ml per {unit}",
    "fridge.item.packHint": "Nodig om gebruikte grammen van de voorraad af te halen",
    "fridge.item.discard": "Weggooien (bedorven of over datum)",
    "fridge.item.discarded": "Weggegooid: {name}",
    "fridge.item.delete": "Niet meer bijhouden",
    "fridge.item.deleteTitle": "“{name}” uit de voorraad verwijderen?",
    "fridge.item.deleteBody": "De voedingswaarde en bijvulherinnering gaan ook weg. Is het alleen op? Laat het staan: bij 0 krijg je een herinnering om bij te kopen.",
    "fridge.item.deleted": "Verwijderd",

    "fridge.add.title": "In de voorraad",
    "fridge.add.scan": "Streepjescode scannen",
    "fridge.add.scanSub": "Aanrader: naam, voedingswaarde en inhoud ingevuld",
    "fridge.add.receipt": "Van een bonnetje",
    "fridge.add.receiptSub": "Nieuw bonnetje of een die er nog niet in staat: huishoudboekje en voorraad in één keer",
    "fridge.add.type": "Naam typen",
    "fridge.add.typeSub": "Groente, fruit en los eten zonder streepjescode",
    "fridge.add.name": "Naam",
    "fridge.add.namePh": "bijv. Tomaten",
    "fridge.add.qty": "Aantal",
    "fridge.add.found": "Gevonden",
    "fridge.add.notFound": "Dit product staat niet in de database. Typ de naam en maak een foto van het etiket.",
    "fridge.add.labelBtn": "Foto van het etiket: voedingswaarde uitlezen",
    "fridge.add.reading": "Etiket lezen… {pct}%",
    "fridge.add.labelRead": "Voedingswaarde gelezen — controleer even",
    "fridge.add.labelFail": "Niet goed leesbaar. Zet het er nu in en vul de voedingswaarde later aan.",
    "fridge.add.save": "In de voorraad",
    "fridge.add.merged": "Lag er al: +{n}",
    "fridge.add.again": "Nog een scannen",
    "fridge.exp.d3": "3 dagen",
    "fridge.exp.w1": "1 week",
    "fridge.exp.w2": "2 weken",
    "fridge.exp.m1": "1 maand",
    "fridge.exp.m3": "3 maanden",
    "fridge.exp.m6": "6 maanden",
    "fridge.exp.y1": "1 jaar",
    "fridge.exp.hint": "Neem de datum van de verpakking over. Leeg gelaten schat de app er een op basis van de plank.",

    "fridge.receipt.button": "In de voorraad",
    "fridge.receipt.skip": "Nu niet",
    "fridge.item.bought": "Gekocht bij {store} · {date}{price} · bekijk bonnetje",
    "fridge.receipt.newPhoto": "Nieuw bonnetje fotograferen (huishoudboekje en voorraad in één keer)",
    "fridge.recipe.title": "Wat kan ik koken?",
    "fridge.recipe.card": "Je kunt koken met wat je hebt",
    "fridge.recipe.ask": "Geen idee wat je maakt? Bekijk gerechten met wat er is",
    "fridge.recipe.intro": "Gewone gerechten gekozen uit je voorraad, met eerst wat bijna over de datum is.",
    "fridge.recipe.none": "Nog niet genoeg voor een gerecht",
    "fridge.recipe.noneSub": "Zet een paar gewone producten in de voorraad (eieren, tomaten, aardappels, vis, vlees) en hier verschijnen ideeën.",
    "fridge.recipe.usesUp": "gebruikt {names} op",
    "fridge.recipe.allHere": "je hebt alles",
    "fridge.recipe.missing": "mist {names}",
    "fridge.recipe.back": "Andere gerechten",
    "fridge.recipe.minutes": "Ongeveer {n} minuten",
    "fridge.recipe.ingredients": "Ingrediënten",
    "fridge.recipe.optional": "optioneel",
    "fridge.recipe.notHome": "niet in huis",
    "fridge.recipe.basics": "Smaakmakers: {names}",
    "fridge.recipe.steps": "Bereiding",
    "fridge.recipe.cookHint": "„Dit maak ik” vult de ingrediënten en hoeveelheden in, berekent calorieën, suiker en zout per portie, en haalt het gebruikte uit de voorraad.",
    "fridge.recipe.cook": "Dit maak ik",
    "fridge.recipe.buy": "De {n} ontbrekende op de lijst",
    "fridge.recipe.listed": "{n} op de boodschappenlijst gezet",
    "fridge.cuisine.chinese": "Chinees",
    "fridge.cuisine.dutch": "Hollands",
    "fridge.cuisine.italian": "Italiaans",
    "fridge.cuisine.french": "Frans",
    "fridge.cuisine.german": "Duits",
    "fridge.cuisine.czech": "Tsjechisch",
    "fridge.cuisine.spanish": "Spaans",
    "fridge.cuisine.indonesian": "Indonesisch / Surinaams",
    "fridge.cuisine.turkish": "Turks / Marokkaans",
    "fridge.cuisine.indian": "Indiaas",
    "fridge.cuisine.korean": "Koreaans",
    "fridge.cuisine.japanese": "Japans",
    "fridge.cuisine.western": "Dagelijks westers",
    "fridge.recipe.likedNow": "Eerst: {names}",
    "fridge.recipe.likedAll": "Alle keukens (tik om favorieten te kiezen)",
    "fridge.recipe.likedHint": "Kies de keukens die jullie lekker vinden (zoveel je wilt); die komen eerst. Kies er geen om alles te zien.",
    "fridge.recipe.ours": "Onze eigen gerechten",
    "fridge.recipe.oursSub": "Dit hebben jullie {n} keer gemaakt.",
    "fridge.recipe.forYou": "Uit jullie favoriete keukens",
    "fridge.recipe.others": "Andere keukens",
    "fridge.recipe.showOthers": "Andere keukens bekijken ({n})",
    "fridge.recipe.cookedTimes": "{n}× gemaakt",
    "fridge.recipe.forget": "Dit gerecht niet meer voorstellen",
    "fridge.recipe.forgotten": "„{name}” wordt niet meer voorgesteld",
    "fridge.energy.open": "Energiebalans van vandaag",
    "fridge.energy.openSub": "Gegeten − verbruikt, tegen je eigen gezondheidsnorm",
    "fridge.energy.title": "Energiebalans van vandaag",
    "fridge.energy.diffTitle": "Balans van vandaag (gegeten − verbruikt)",
    "fridge.energy.deficit": "Vandaag een tekort: meer verbruikt dan gegeten — ongeveer {kg} kg lichaamsvet.",
    "fridge.energy.surplus": "Vandaag een overschot: meer gegeten dan verbruikt — ongeveer {kg} kg vet opgeslagen.",
    "fridge.energy.even": "Gegeten en verbruikt zijn vandaag ongeveer gelijk: je gewicht blijft.",
    "fridge.energy.formula": "De formule, met jouw getallen",
    "fridge.energy.f.bmr": "Ruststofwisseling (Mifflin–St Jeor) = 10 × gewicht {w} + 6,25 × lengte {h} − 5 × leeftijd {a} {s} = {v} kcal",
    "fridge.energy.f.life": "Dagelijks leven = ruststofwisseling {bmr} × activiteitsfactor {f} ({act}) = {v} kcal",
    "fridge.energy.f.exercise": "Sport vandaag genoteerd = {v} kcal ({min} min)",
    "fridge.energy.f.burned": "Verbruikt vandaag = {life} + {ex} = {v} kcal",
    "fridge.energy.f.calib": "Persoonlijke correctie = {v} kcal (uit je gewichtsverloop)",
    "fridge.energy.f.burnedCal": "Verbruikt vandaag = {life} + {ex} + ({calib}) = {v} kcal",
    "fridge.energy.cal.title": "Tegen je echte gewicht",
    "fridge.energy.cal.notYet": "Daarvoor zijn minstens 2 weken nodig met eten op de meeste dagen genoteerd en twee wegingen minstens 14 dagen uit elkaar.",
    "fridge.energy.cal.compare": "Laatste {days} dagen ({logged} met eten genoteerd): volgens de formule {pred} kg, je gewicht veranderde {act} kg.",
    "fridge.energy.cal.fits": "De formule past goed bij je lichaam: geen correctie nodig.",
    "fridge.energy.cal.more": "Je lichaam verbruikt ongeveer {v} kcal per dag meer dan de formule zegt.",
    "fridge.energy.cal.less": "Je lichaam verbruikt ongeveer {v} kcal per dag minder dan de formule zegt (of er is eten niet genoteerd).",
    "fridge.energy.cal.apply": "Corrigeer naar de werkelijkheid ({v} kcal per dag)",
    "fridge.energy.cal.clear": "Correctie weghalen (nu {v} kcal)",
    "fridge.energy.f.eaten": "Gegeten vandaag = {v} kcal ({n} dingen genoteerd)",
    "fridge.energy.f.diff": "Balans = gegeten {eaten} − verbruikt {burned} = {v} kcal ≈ {kg} kg lichaamsvet ({per} kcal ≈ 1 kg)",
    "fridge.energy.standard": "Tegen mijn gezondheidsnorm",
    "fridge.energy.goal.own": "Caloriënorm: je eigen {v} kcal per dag.",
    "fridge.energy.goal.slim": "Caloriënorm (afvallen): verbruikt {burned} − {d} = {v} kcal.",
    "fridge.energy.goal.keep": "Caloriënorm (gewicht houden): wat je verbruikt, {v} kcal.",
    "fridge.energy.left": "Nog {v} kcal over voor vandaag.",
    "fridge.energy.over": "Vandaag {v} kcal te veel.",
    "fridge.energy.sugar": "Suiker: vandaag {v} g / grens {max} g",
    "fridge.energy.salt": "Zout: vandaag {v} g / grens {max} g",
    "fridge.energy.bmi": "BMI = gewicht {w} ÷ lengte {h}² = {v} ({band}; 18,5–24,9 is gezond)",
    "fridge.energy.band.under": "ondergewicht",
    "fridge.energy.band.normal": "gezond",
    "fridge.energy.band.over": "overgewicht",
    "fridge.energy.band.obese": "obesitas",
    "fridge.energy.note": "Zolang de dag niet voorbij is, verandert dit nog door wat je eet en doet — na het avondeten is het het nauwkeurigst. Dit zijn schattingen, geen medisch advies; je grenzen voor suiker, zout en calorieën stel je in bij Eten › Doelen.",
    "fridge.energy.toMeals": "Eten en sport noteren",
    "fridge.energy.editBody": "Lichaamsgegevens wijzigen",
    "fridge.energy.form.intro": "Om je verbruik te berekenen is dit nodig; het wordt alleen voor de berekening gebruikt en aan niemand getoond.",
    "fridge.energy.form.sex": "Geslacht",
    "fridge.energy.form.year": "Geboortejaar",
    "fridge.energy.form.height": "Lengte (cm)",
    "fridge.energy.form.weight": "Gewicht nu (kg)",
    "fridge.energy.form.weightFrom": "Laatste in je gewichtslog: {date}",
    "fridge.energy.form.activity": "Dagelijkse activiteit (zonder sport die je apart noteert)",
    "fridge.energy.form.save": "Opslaan en berekenen",
    "fridge.energy.form.invalid": "Vul alles in: geboortejaar, lengte 80–250 cm, gewicht 20–400 kg, en kies geslacht en activiteit.",
    "fridge.energy.sex.female": "Vrouw",
    "fridge.energy.sex.male": "Man",
    "fridge.energy.act.sedentary": "Zittend",
    "fridge.energy.act.light": "Licht actief",
    "fridge.energy.act.moderate": "Gemiddeld actief",
    "fridge.energy.act.active": "Actief",
    "fridge.energy.act.very": "Zeer actief",
    "fridge.energy.actHint.sedentary": "Vooral zitten, weinig lopen",
    "fridge.energy.actHint.light": "Zittend werk, elke dag wat lopen en huishouden",
    "fridge.energy.actHint.moderate": "Veel staan of lopen, bijv. winkelwerk, jonge kinderen",
    "fridge.energy.actHint.active": "Lichamelijk werk, of elke dag sporten",
    "fridge.energy.actHint.very": "Zwaar lichamelijk werk, of elke dag hard trainen",
    "fridge.baby.open": "Koken voor de kleine",
    "fridge.baby.openSub": "Babyvoeding van wat er is, per leeftijd",
    "fridge.baby.title": "Wat koken voor de kleine?",
    "fridge.baby.intro": "Baby- en peutereten per leeftijd, van wat er in je voorraad is — eerst wat bijna over de datum is.",
    "fridge.baby.ageLabel": "Hoe oud",
    "fridge.baby.age.6m": "6–8 maanden (hapjes)",
    "fridge.baby.age.9m": "9–12 maanden (prakjes, vingervoedsel)",
    "fridge.baby.age.1y": "1–3 jaar (kleine pot van de pot)",
    "fridge.baby.rulesTitle": "Goed om te weten op deze leeftijd",
    "fridge.baby.rules.6m.1": "Begin met vast voedsel rond 6 maanden; borstvoeding of flesvoeding blijft het belangrijkst.",
    "fridge.baby.rules.6m.2": "Geen zout, suiker, sojasaus of bouillon — en nooit honing vóór 1 jaar.",
    "fridge.baby.rules.6m.3": "Eén nieuw product tegelijk, dan 3 dagen wachten voor het volgende.",
    "fridge.baby.rules.6m.4": "Begin met gladde hapjes, 1–2 theelepels; vlees, vis en ei altijd goed gaar.",
    "fridge.baby.rules.9m.1": "Van gepureerd naar geprakt en zachte stukjes, om te leren kauwen en zelf te eten.",
    "fridge.baby.rules.9m.2": "Nog steeds geen zout, suiker of honing; elke dag wat ijzerrijk vlees, vis of ei.",
    "fridge.baby.rules.9m.3": "Druiven, blauwe bessen en cherrytomaatjes in vieren; geen hele noten, popcorn of harde snoepjes.",
    "fridge.baby.rules.9m.4": "Altijd rechtop zitten, met een volwassene erbij.",
    "fridge.baby.rules.1y.1": "Kleine, fijngesneden porties van de pot — haal het kinderdeel eruit vóór het kruiden; zo min mogelijk zout (onder 2 g per dag bij 1–3 jaar).",
    "fridge.baby.rules.1y.2": "Weinig suiker, geen zoete drankjes of sap; ongeveer 300–500 ml melk per dag.",
    "fridge.baby.rules.1y.3": "Geen hele noten vóór 5 jaar; kleine ronde dingen doorsnijden.",
    "fridge.baby.rules.1y.4": "Weinig worst, ham of ander bewerkt vlees, en geen erg zoute kaas.",
    "fridge.baby.none": "Nog niet genoeg voor een babymaaltijd",
    "fridge.baby.noneSub": "Zet wat groente (wortel, broccoli, aardappel), fruit (banaan, appel), eieren, vis of vlees, rijst of havermout in de voorraad en hier verschijnen gerechtjes.",
    "fridge.baby.portion": "ca. {g} g per maaltijd",
    "fridge.baby.iron": "IJzer",
    "fridge.baby.ironWhy": "Vlees, vis en ei zijn rijk aan ijzer. Vanaf 6 maanden raakt de eigen ijzervoorraad van een baby op, dus elke dag wat ijzerrijks is belangrijk.",
    "fridge.baby.allergenShort": "bevat {list}",
    "fridge.baby.allergens": "Bevat veelvoorkomende allergenen: {list}. Geef de eerste keer één klein lepeltje en 2–3 dagen niets anders nieuws; let op uitslag, spugen of diarree.",
    "fridge.baby.allergen.egg": "ei",
    "fridge.baby.allergen.fish": "vis",
    "fridge.baby.allergen.shellfish": "schaaldieren",
    "fridge.baby.allergen.milk": "melk",
    "fridge.baby.allergen.wheat": "tarwe",
    "fridge.baby.allergen.soy": "soja",
    "fridge.baby.allergen.peanut": "pinda",
    "fridge.baby.avoid": "Niet voor de kleine uit je voorraad",
    "fridge.baby.why.honey": "geen honing vóór 1 jaar (risico op zuigelingenbotulisme)",
    "fridge.baby.why.nuts": "hele noten: verslikkingsgevaar; fijngemalen notenpasta mag",
    "fridge.baby.why.processed": "bewerkt, gezouten en gerookt eten is te zout",
    "fridge.baby.why.junk": "te zoet of te zout voor een kind",
    "fridge.baby.why.seasoning": "geen kruiden of zout vóór 1 jaar",
    "fridge.baby.why.cheese": "te zout; vanaf 1 jaar een beetje",
    "fridge.baby.disclaimer": "Algemene adviezen voor de eerste hapjes, geen medisch advies; bij allergie, vroeggeboorte of andere bijzonderheden eerst het consultatiebureau of de huisarts vragen.",
    "fridge.baby.back": "Andere babymaaltijden",
    "fridge.baby.raw": "rauw prakken",
    "fridge.baby.steamFirst": "eerst zacht stomen",
    "fridge.baby.quarters": "altijd in vieren snijden",
    "fridge.baby.dish.vegPuree": "Hapje van {main}",
    "fridge.baby.dish.fruitPuree": "Fruithapje van {main}",
    "fridge.baby.dish.porridge": "Pap van {main}",
    "fridge.baby.dish.proteinPuree": "Hapje van {all}",
    "fridge.baby.dish.eggMash": "Geprakte eidooier",
    "fridge.baby.dish.congee": "Rijstepap met {all}",
    "fridge.baby.dish.fingerVeg": "Gestoomde reepjes {all} (vingervoedsel)",
    "fridge.baby.dish.omelette": "Omeletreepjes met {others}",
    "fridge.baby.dish.pastaMince": "Zachte pasta met {all}",
    "fridge.baby.dish.fruitPieces": "Zachte stukjes {main} (vingervoedsel)",
    "fridge.baby.dish.softRice": "Zachte rijst met {all}",
    "fridge.baby.dish.eggNoodles": "Mie met ei en {all}",
    "fridge.baby.dish.meatballs": "Balletjes van {all}",
    "fridge.baby.steps.vegPuree.1": "Was en schil de {main}, snijd klein en stoom of kook tot het met een lepel plat gaat (15–20 minuten).",
    "fridge.baby.steps.vegPuree.2": "Pureer heel glad met wat kookvocht, borstvoeding of flesvoeding; geen zout of suiker.",
    "fridge.baby.steps.vegPuree.3": "Lauw geven, beginnen met 1–2 theelepels. De rest in porties invriezen en binnen een maand gebruiken.",
    "fridge.baby.steps.fruitPuree.1": "Was, schil en ontpit de {main}. Banaan, avocado en mango rauw prakken; appel en peer eerst 8–10 minuten stomen.",
    "fridge.baby.steps.fruitPuree.2": "Glad prakken; zo nodig verdunnen met wat borst- of flesvoeding.",
    "fridge.baby.steps.fruitPuree.3": "Vers maken, zonder suiker.",
    "fridge.baby.steps.porridge.1": "Kook de {main} op laag vuur heel zacht in 8–10 keer zoveel water (havermout: 5 keer).",
    "fridge.baby.steps.porridge.2": "Glad pureren; eventueel verdunnen met {others} (melk is vóór 1 jaar geen drank, maar een beetje in het eten mag).",
    "fridge.baby.steps.porridge.3": "Geen suiker of zout; lauw geven.",
    "fridge.baby.steps.proteinPuree.1": "Haal vel en botjes van de {main} — vis goed op graatjes controleren; snijd klein en kook of stoom helemaal gaar, niet meer roze.",
    "fridge.baby.steps.proteinPuree.2": "Pureer met de {others} en wat kookvocht of water (vanaf 9 maanden wat grover).",
    "fridge.baby.steps.proteinPuree.3": "Geen zout of sojasaus. Restjes in porties invriezen en binnen een maand gebruiken.",
    "fridge.baby.steps.eggMash.1": "Ei in koud water, aan de kook brengen en nog 10 minuten koken — helemaal hard.",
    "fridge.baby.steps.eggMash.2": "Pellen, eerst de dooier prakken en verdunnen met borst- of flesvoeding of lauw water.",
    "fridge.baby.steps.eggMash.3": "Gaat de dooier een paar keer goed, probeer dan het eiwit.",
    "fridge.baby.steps.congee.1": "Spoel de {main} en laat in 6–8 keer zoveel water zacht garen tot pap (ongeveer 40 minuten).",
    "fridge.baby.steps.congee.2": "Hak de {others} heel fijn (vlees goed gaar, vis zonder graat) en laat nog 10 minuten meekoken.",
    "fridge.baby.steps.congee.3": "Druk aan met een lepel en laat kleine stukjes zitten om te leren kauwen. Geen zout.",
    "fridge.baby.steps.fingerVeg.1": "Snijd de {all} in vingerdikke reepjes, iets langer dan het knuistje, of kleine roosjes.",
    "fridge.baby.steps.fingerVeg.2": "Stoom tot het tussen je vingers plat te drukken is (8–12 minuten); laat afkoelen.",
    "fridge.baby.steps.fingerVeg.3": "Laat het kind rechtop zitten en zelf eten, met een volwassene erbij.",
    "fridge.baby.steps.omelette.1": "Klop het ei los en meng de heel fijngehakte {others} erdoor; geen zout.",
    "fridge.baby.steps.omelette.2": "Wrijf een antiaanbakpan in met een druppel olie; bak op laag vuur aan beide kanten tot helemaal gestold.",
    "fridge.baby.steps.omelette.3": "Snijd in vingerbrede reepjes om zelf te eten (vanaf 1 jaar kleine stukjes).",
    "fridge.baby.steps.pastaMince.1": "Kook de {main} 2–3 minuten langer dan op de verpakking staat, tot zacht; knip in korte stukjes.",
    "fridge.baby.steps.pastaMince.2": "Hak de {others} en laat in wat water gaar en zacht worden (vlees helemaal gaar, vis zonder graat).",
    "fridge.baby.steps.pastaMince.3": "Door elkaar; bij 9–12 maanden wat prakken, vanaf 1 jaar klein snijden. Geen zout of sojasaus.",
    "fridge.baby.steps.fruitPieces.1": "Was, schil en ontpit de {main}; snijd in vingerdikke reepjes of zachte stukjes — druiven, bessen en cherrytomaatjes altijd in vieren.",
    "fridge.baby.steps.fruitPieces.2": "Hard fruit (appel, peer) eerst 5 minuten zacht stomen.",
    "fridge.baby.steps.fruitPieces.3": "Laat het kind rechtop zitten en zelf eten, met een volwassene erbij.",
    "fridge.baby.steps.softRice.1": "Kook de {main} met extra water zacht.",
    "fridge.baby.steps.softRice.2": "Snijd de {others} in blokjes van ongeveer 1 cm en stoom of kook gaar; vlees helemaal, vis zonder graat.",
    "fridge.baby.steps.softRice.3": "Door de rijst; zo min mogelijk zout — tomaat en ui geven smaak.",
    "fridge.baby.steps.eggNoodles.1": "Kook de mie zacht en knip in korte stukjes.",
    "fridge.baby.steps.eggNoodles.2": "Hak de {others}, laat zacht worden in een beetje olie, voeg het losgeklopte ei toe en bak tot helemaal gestold.",
    "fridge.baby.steps.eggNoodles.3": "Door de mie; geen zout of sojasaus — tomaat geeft genoeg smaak.",
    "fridge.baby.steps.meatballs.1": "Hak de {main} fijn (vis zorgvuldig zonder graat), de {others} heel klein, meng en voeg eventueel wat havermout toe.",
    "fridge.baby.steps.meatballs.2": "Rol kleine balletjes; 15 minuten stomen of koken tot helemaal gaar.",
    "fridge.baby.steps.meatballs.3": "Plat drukken of halveren voor je het geeft; geen zout.",
    "fridge.health.label": "Kies voor mijn gezondheid:",
    "fridge.health.all": "Alles",
    "fridge.health.weight": "Afvallen",
    "fridge.health.sugar": "Minder suiker",
    "fridge.health.salt": "Minder zout",
    "fridge.health.fromGoal": "Volgens je doel bij Eten › Doelen: {goal}.",
    "fridge.health.noGoal": "Stel je gezondheidsdoel in bij Eten › Doelen, dan worden de gerechten hier daarop gekozen.",
    "fridge.health.limits": "Liefst per persoon voor deze maaltijd: tot {kcal} kcal · {sugar} g suiker · {carbs} g koolhydraten · {salt} g zout",
    "fridge.health.per": "per persoon ca. {kcal} kcal · suiker {sugar} g · zout {salt} g",
    "fridge.health.perLong": "Per persoon ca.: {kcal} kcal · eiwit {protein} g · vet {fat} g · koolhydraten {carbs} g · suiker {sugar} g · zout {salt} g",
    "fridge.health.partial": "Van sommige ingrediënten zijn geen voedingswaarden bekend; in werkelijkheid is het iets meer.",
    "fridge.health.tip.lessSalt": "Gezonder: de helft van het zout en de sojasaus — geef smaak met knoflook, gember, bosui, citroen of azijn.",
    "fridge.health.tip.lessOil": "Gezonder: de helft van de olie; gebruik een antiaanbakpan, of stoom of kook in plaats van bakken.",
    "fridge.health.tip.noSugar": "Gezonder: geen suiker toevoegen.",
    "fridge.health.none": "Niets in huis past nu bij „{goal}”. Probeer een andere keuze, of kijk naar het gezonde bord hieronder.",
    "fridge.health.hidden": "Nog {n} gerechten passen minder goed bij „{goal}” en zijn ingeklapt.",
    "fridge.plate.title": "Gezond bord van wat er is",
    "fridge.plate.sub": "Mager eiwit + groente + een afgemeten portie rijst of aardappelen, weinig olie en zout, afgestemd op je doel.",
    "fridge.plate.name.steam": "Gestoomde {protein} met {veg}",
    "fridge.plate.name.egg": "{protein} roergebakken met {veg}",
    "fridge.plate.name.stirfry": "Licht roergebakken {protein} met {veg}",
    "fridge.plate.withStaple": "{dish}, met {staple}",
    "fridge.plate.another": "Andere combinatie",
    "fridge.plate.see": "Zo maak je het",
    "fridge.plate.none": "Voor een gezond bord is één eiwit (vis, garnalen, kip, eieren, tofu…) en één groente in de voorraad nodig.",
    "fridge.plate.steam.1": "Spoel de {protein} af en leg op een bord, met gember en bosui erop als je die hebt; stoom 8–12 minuten boven kokend water (garnalen 5).",
    "fridge.plate.egg.1": "Klop de eieren los zonder zout. Verhit de helft van de olie en roerbak tot ze net gestold zijn; haal eruit.",
    "fridge.plate.stirfry.1": "Snijd de {protein} in kleine stukjes. Verhit de helft van de olie en roerbak op hoog vuur tot gaar; haal eruit.",
    "fridge.plate.veg": "Was en snijd de {veg}; roerbak 2–3 minuten in een beetje olie, of blancheer 1–2 minuten in kokend water zodat het knapperig blijft.",
    "fridge.plate.season": "Maak af met maar {soy} g sojasaus (ca. {spoons} theelepel) en geen extra zout; een beetje knoflook of citroen geeft smaak.",
    "fridge.plate.staple": "Kook {g} g (ongekookt) {staple} per persoon — en niet nog eens opscheppen.",
    "fridge.plate.order": "Eet eerst de groente en {protein}, de {staple} als laatste: je bloedsuiker stijgt dan rustiger.",
    "fridge.cook.seeDay": "Bekijk mijn dag",
    "fridge.cook.keep": "Bewaren als eigen gerecht (wordt weer voorgesteld als dit eten in huis is)",
    "fridge.add.price": "Wat het kostte (optioneel)",
    "fridge.add.priceHint": "Zonder bon? Vul het in: het komt in het huishoudboekje onder „Boodschappen (zonder bon)”.",
    "fridge.add.booked": "{amount} in het huishoudboekje",
    "fridge.receipt.title": "Het eten van een bonnetje in de voorraad zetten",
    "fridge.receipt.pick": "Kies een bonnetje",
    "fridge.receipt.noRecords": "Geen bonnetjes meer die nog niet in de voorraad staan.",
    "fridge.receipt.hint": "Statiegeld, tassen en huishoudartikelen zijn weggelaten. De plank is geraden; tik om te wijzigen.",
    "fridge.receipt.none": "Niets op dit bonnetje hoort in de voorraad.",
    "fridge.receipt.save": "In de voorraad ({n})",
    "fridge.receipt.done": "{added} nieuw, {merged} aangevuld",

    "fridge.cook.title": "Iets koken",
    "fridge.cook.name": "Gerecht",
    "fridge.cook.namePh": "bijv. Pasta met tomaat",
    "fridge.cook.pick": "Welke ingrediënten uit de voorraad?",
    "fridge.cook.basics": "Kruiden en vet (zout en olie tellen het zwaarst)",
    "fridge.cook.basic.salt": "Zout",
    "fridge.cook.basic.sugar": "Suiker",
    "fridge.cook.basic.oil": "Olie",
    "fridge.cook.basic.butter": "Boter",
    "fridge.cook.basic.soySauce": "Sojasaus",
    "fridge.cook.spoon": "1 lepel ≈ {g} g",
    "fridge.cook.grams": "g",
    "fridge.cook.half": "½ {unit}",
    "fridge.cook.whole": "1 {unit}",
    "fridge.cook.servings": "Porties gemaakt",
    "fridge.cook.eat": "Porties gegeten",
    "fridge.cook.perServing": "Per portie (berekend uit de ingrediënten)",
    "fridge.cook.estimated": "Geschat met gangbare waarden: {names} (scan de barcode of fotografeer het etiket voor precieze cijfers)",
    "fridge.cook.missing": "{names}: geen voedingswaarde, niet meegeteld",
    "fridge.cook.deduct": "Gebruikte hoeveelheid van de voorraad afhalen",
    "fridge.cook.save": "Bijhouden als {meal} van vandaag",
    "fridge.cook.saveOnly": "Alleen voorraad bijwerken",
    "fridge.cook.saved": "Bijgehouden: {name}, {kcal} kcal per portie",
    "fridge.cook.listed": "{names} op: op het boodschappenlijstje gezet",
    "fridge.cook.empty": "Nog geen ingrediënten met voedingswaarde. Scan er een paar die je vaak gebruikt.",
    "fridge.cook.remove": "Weghalen",
  },
} satisfies Dict;
